(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-article"]) return;
  try {
    
  (() => {
    const body = document.querySelector('[data-sm-article-body]');
    const toc = document.querySelector('[data-sm-toc]');

    if (body && toc) {
      const list = toc.querySelector('.art-toc-list');
      const koppen = [...body.querySelectorAll('h2')];
      const min = Number(toc.dataset.min || 3);

      // Onder de drempel blijft de inhoudsopgave verborgen: een lijstje van één
      // regel is ruis, geen navigatie.
      if (koppen.length >= min) {
        const links = koppen.map((kop, i) => {
          if (!kop.id) kop.id = `sectie-${i + 1}`;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${kop.id}`;
          a.textContent = kop.textContent.trim();
          li.append(a);
          list.append(li);
          return a;
        });

        toc.hidden = false;
        // Op smal scherm staat hij bovenaan de tekst; open zou daar een halve
        // pagina kosten.
        toc.open = !window.matchMedia('(max-width: 980px)').matches;

        const zichtbaar = new Set();
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) zichtbaar.add(entry.target.id);
              else zichtbaar.delete(entry.target.id);
            });
            const eerste = koppen.find((kop) => zichtbaar.has(kop.id));
            links.forEach((a) => {
              if (eerste && a.hash === `#${eerste.id}`) a.setAttribute('aria-current', 'true');
              else a.removeAttribute('aria-current');
            });
          },
          { rootMargin: '-80px 0px -70% 0px' }
        );
        koppen.forEach((kop) => observer.observe(kop));
      }
    }

    document.querySelectorAll('[data-sm-copy]').forEach((knop) => {
      const label = knop.querySelector('[data-sm-copy-label]');
      const origineel = label.textContent;
      knop.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          label.textContent = knop.dataset.done;
          setTimeout(() => {
            label.textContent = origineel;
          }, 2000);
        } catch {
          // Clipboard geweigerd (geen https, of gebruiker zei nee) — dan blijft
          // het label staan. Een foutmelding voor "kopieer link" is erger dan
          // niets doen.
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-bezorgdag"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];

    // De bezorgdag is één regel met drie takken. `bezorgdagen` is de lijst
    // weekdagnummers waarop de vervoerder rijdt (0 = zondag), zodat een extra
    // zaterdagrit een thema-instelling is en geen codewijziging.
    function bezorgdag(index, opTijd, bezorgdagen) {
      if (bezorgdagen.indexOf(index) !== -1 && opTijd) return index;
      var loop = index;
      for (var stap = 0; stap < 7; stap++) {
        loop = (loop + 1) % 7;
        if (bezorgdagen.indexOf(loop) !== -1) return loop;
      }
      return index;
    }

    function bouw(kaart) {
      if (kaart.dataset.bezorgdagKlaar === '1') return;
      kaart.dataset.bezorgdagKlaar = '1';

      var velden = kaart.querySelector('[data-bezorgdag-velden]');
      var rijDagen = kaart.querySelector('[data-bezorgdag-dagen]');
      var rijTijden = kaart.querySelector('[data-bezorgdag-tijden]');
      var antwoord = kaart.querySelector('[data-bezorgdag-antwoord]');
      var sub = kaart.querySelector('[data-bezorgdag-sub]');
      var voet = kaart.querySelector('[data-bezorgdag-voet]');
      if (!velden || !rijDagen || !rijTijden || !antwoord) return;

      var cutoff = parseInt(kaart.dataset.cutoff, 10) || 10;
      var van = kaart.dataset.vensterVan || '17:00';
      var tot = kaart.dataset.vensterTot || '22:00';
      var zone = kaart.dataset.tijdzone || 'Europe/Amsterdam';
      var bezorgdagen = (kaart.dataset.bezorgdagen || '1,2,3,4,5')
        .split(',')
        .map(function (n) {
          return parseInt(n, 10);
        })
        .filter(function (n) {
          return n >= 0 && n <= 6;
        });

      // Dag- en zinsteksten komen uit de locale (data-attributen in de markup);
      // `%DAG%` is de plek van de dagnaam. Index 0 = zondag, net als getDay().
      var namen = (kaart.dataset.dagen || '').split('|');
      var namenKlein = (kaart.dataset.dagenKlein || '').split('|');
      function tekst(sleutel, dag) {
        return (kaart.getAttribute('data-t-' + sleutel) || '').replace('%DAG%', dag);
      }

      ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'].forEach(function (kort) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.dataset.dag = String(KORT.indexOf(kort));
        knop.textContent = namen[KORT.indexOf(kort)].slice(0, 2);
        knop.setAttribute('aria-label', namen[KORT.indexOf(kort)]);
        knop.setAttribute('aria-pressed', 'false');
        rijDagen.appendChild(knop);
      });

      var nu = new Date(new Date().toLocaleString('en-US', { timeZone: zone }));
      var vandaag = nu.getDay();
      var staat = { dag: vandaag, opTijd: nu.getHours() < cutoff };

      function stempel(rij, sleutel, waarde) {
        rij.querySelectorAll('button').forEach(function (knop) {
          knop.setAttribute('aria-pressed', String(knop.dataset[sleutel] === waarde));
        });
      }

      function toon() {
        var rijdtVandaag = bezorgdagen.indexOf(staat.dag) !== -1;
        rijTijden.querySelectorAll('button').forEach(function (knop) {
          knop.disabled = !rijdtVandaag;
        });

        stempel(rijDagen, 'dag', String(staat.dag));
        stempel(rijTijden, 'tijd', rijdtVandaag ? (staat.opTijd ? 'voor' : 'na') : '');

        var uit = bezorgdag(staat.dag, staat.opTijd, bezorgdagen);
        var vanavond = uit === staat.dag && staat.dag === vandaag && staat.opTijd;
        antwoord.textContent = vanavond
          ? tekst('vanavond')
          : tekst('dagavond', namen[uit]);

        if (sub) {
          if (!rijdtVandaag) {
            sub.textContent = tekst('weekend', namenKlein[uit]);
          } else if (staat.opTijd) {
            sub.textContent = tekst('optijd');
          } else {
            sub.textContent = tekst('telaat', namenKlein[uit]);
          }
        }

        if (voet) {
          if (staat.dag !== vandaag) {
            voet.textContent = tekst('andere', namenKlein[staat.dag]);
          } else if (!rijdtVandaag) {
            voet.textContent = tekst('nu', namenKlein[vandaag]);
          } else {
            voet.textContent = tekst(staat.opTijd ? 'nu-voor' : 'nu-na', namenKlein[vandaag]);
          }
        }
      }

      rijDagen.addEventListener('click', function (e) {
        var knop = e.target.closest('button');
        if (!knop) return;
        staat.dag = parseInt(knop.dataset.dag, 10);
        if (bezorgdagen.indexOf(staat.dag) === -1) staat.opTijd = true;
        toon();
      });

      rijTijden.addEventListener('click', function (e) {
        var knop = e.target.closest('button');
        if (!knop || knop.disabled) return;
        staat.opTijd = knop.dataset.tijd === 'voor';
        toon();
      });

      velden.hidden = false;
      toon();
    }

    function start() {
      document.querySelectorAll('[data-bezorgdag]').forEach(bouw);
    }

    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-cart-drawer"]) return;
  try {
    
  // Eén gedelegeerde laag voor alle wagenacties: toevoegen op elke pagina,
  // aantal wijzigen in de drawer en op de kaart, en de drawer openen.
  // Delegeren is hier geen stijlkeuze — de drawerinhoud wordt na elke mutatie
  // vervangen, dus een listener die aan een knop hangt is daarna weg.
  //
  // Alles staat in een IIFE, net als in `cart.liquid`. Shopify plakt het
  // javascript-blok van élke sectie aan elkaar in één bestand met één top-level
  // scope; namen als `root` of `verversen` zijn precies generiek genoeg dat een
  // latere sectie ze opnieuw declareert. Dat is dan geen conflict in deze sectie
  // maar een SyntaxError in het hele gebundelde bestand — waarmee ook de
  // hertelling van de afrekenknop op de wagenpagina stilvalt.
  (function () {
  const SECTIE = 'sm-cart-drawer';

  // Eén vlag voor toevoegen én wijzigen. Zonder gedeelde vlag zit er een gat: de
  // stapknoppen gaan wel op slot, maar een koopknop niet, dus een toevoeging kan
  // over een lopende wijziging heen landen en de drawer met een oudere
  // momentopname overschrijven — inclusief een afrekenknop die openstaat op een
  // wagen die de drempel niet meer haalt.
  let bezig = false;

  // Wagenverzoeken staan achter elkaar in plaats van naast elkaar.
  //
  // Hier stond alleen `bezig` als poort, en een tweede klik werd daarmee
  // gewéigerd in plaats van uitgesteld. Voor de toevoegknop viel dat oordeel
  // vóór `preventDefault()`, dus postte het formulier daarna gewoon native:
  // volledige paginalading en een redirect naar /cart. Gemeten op de preview met
  // drie kaarten vlak na elkaar — twee van de drie kliks navigeerden weg. Dat is
  // precies de storing die de AJAX-route moest voorkomen.
  //
  // `openTaken` en niet een enkele boolean: `bezig` moet aanstaan zolang er
  // íets in de rij zit, niet alleen tijdens de taak die nu loopt. De stepper
  // hieronder leest hem om een klik te laten vallen, en dat oordeel moet ook
  // kloppen als er nog twee toevoegingen wachten.
  let wachtrij = Promise.resolve();
  let openTaken = 0;
  function inWachtrij(taak) {
    openTaken += 1;
    bezig = true;
    // `.then(taak, taak)`: een mislukte taak mag de rij niet laten stilvallen.
    const klaar = wachtrij.then(taak, taak);
    wachtrij = klaar.catch(() => {}).then(() => {
      openTaken -= 1;
      if (openTaken === 0) bezig = false;
    });
    return klaar;
  }

  const root = () => document.querySelector('[data-cart-root]');
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const wagenUrl = (pad) => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + pad;

  // POST met één herhaalpoging. Alleen voor idempotente schrijfacties (een aantal
  // op 0 zetten, de volledige attribuutstand): opnieuw sturen kan daar niets
  // verdubbelen. Een 429 krijgt wat langer rust. Geeft de Response of null.
  async function wagenPost(pad, body, keepalive = false) {
    for (let poging = 0; poging < 2; poging += 1) {
      const r = await fetch(wagenUrl(pad), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
        keepalive,
      }).catch(() => null);
      if (r && r.ok) return r;
      if (poging === 0) await new Promise((klaar) => setTimeout(klaar, r && r.status === 429 ? 1200 : 400));
    }
    return null;
  }

  // Alles wat nog onderweg is eerst laten landen: aantallen die nog in de
  // rustpauze wachten gaan meteen de rij in, daarna wachten tot de rij leeg is.
  // `while` en niet één `await wachtrij`: een taak kan tijdens het wachten een
  // volgende inplannen. Codex-review 11-10: de afrekenknop wachtte alleen op de
  // cadeaus en kon een lopende toevoeging overslaan.
  async function alleTakenKlaar() {
    [...qtyTimers.keys()].forEach((key) => {
      clearTimeout(qtyTimers.get(key));
      qtySchrijven(key);
    });
    while (openTaken > 0) await wachtrij;
    // PostHog-identiteit op de wagen vóór de checkout (sm-posthog-wagen); plafond 1,5 s.
    await window.smPhWagen?.klaar();
  }

  // Een cadeau-sync die niet lukte houdt de checkout tegen (fail-closed) en zegt
  // dat in de la. De knop gaat weer open: een volgende klik probeert de hele sync
  // opnieuw, en faalt die weer, dan staat de klant weer hier — nooit in de
  // checkout met een cadeau dat niet (meer) verdiend is.
  function syncMislukt() {
    const knop = document.querySelector('#cd-form [name="checkout"]');
    if (knop && !knop.hasAttribute('aria-disabled')) knop.disabled = false;
    const tekst =
      document.querySelector('[data-cart-inner] [data-cart-sync-fout]')?.dataset.cartSyncFout ||
      'Je winkelwagen kon niet worden bijgewerkt. Probeer het opnieuw.';
    if (drawer()) openen();
    tryoutMelden(tekst);
  }

  // Een toevoeging die de pagina verlaat (doorsturen naar /cart, native submit)
  // laat zijn knop dicht staan; komt de klant via de terugknop terug, dan zet
  // `pageshow` die knoppen weer open (gemerkt met `data-cd-bezig`).
  let navigeert = false;

  /* ── Try-out: max. één per bestelling (besluit Joey 04-10-2026) ──────────
   * Vier doelen = vier producten (`try-out-*`), dus "max. 1" geldt over alle
   * vier samen. Gekozen route: een nieuwe try-out VERVANGT de oude, met een
   * melding — niet blokkeren. Wie een tweede try-out toevoegt heeft meestal
   * van doel gewisseld; een weigering laat hem zelf de oude zoeken en
   * weghalen, terwijl de nieuwe zijn eigen zeven keuzes al draagt.
   *
   * Twee routes, afhankelijk van de checkout-validatie `tryout-max-een`:
   *  · regel UIT: eerst toevoegen, dan de oude weg (`tryoutEnkel`). Mislukt de
   *    toevoeging, dan blijft de oude gewoon staan.
   *  · regel AAN: een cart-validatie draait al op /cart/add (gemeten 05-10, 422
   *    met de function-melding), dus twee try-outs bestaan nooit, ook niet even.
   *    Dan eerst de oude weg, dán toevoegen, en de oude terug als dat mislukt
   *    (`tryoutWisselen`). Zie memory checkout-validatie-blokkeert-al-bij-cart-add.
   * Dezelfde try-out met dezelfde keuzes landt in Shopify op dezelfde regel
   * (aantal 2); die gaat terug naar 1.
   * Herkenning op de handle: /cart.js draagt geen template-suffix. Liquid
   * toetst suffix én handle (stepper en vlag hierboven). De afrekenkant
   * (Shopify Function) handhaaft los hiervan; dit is de vriendelijke laag.
   * Een kennismakingspakket telt mee: één try-out óf kennismaking per bestelling,
   * dus het een vervangt het ander. */
  const isTryout = (regel) =>
    typeof regel?.handle === 'string' &&
    (regel.handle.startsWith('try-out-') || regel.handle.startsWith('kennismakingspakket-'));

  // Gemak, geen poort: de checkout-validatie (Shopify Function) is de harde
  // grens. Daarom bewust simpel (Codex-review 04-10-2026, drie rondes):
  //   · null           — niets te doen.
  //   · { ok: true }   — update.js 2xx én verse HTML (direct of via één losse
  //                      sectie-fetch). Alleen dán de melding "vervangen".
  //   · { ok: false }  — al het andere. Nooit een oude snapshot: `html` is de
  //                      echte wagen uit één losse sectie-fetch, of null — dan
  //                      blijft de la zoals hij is en volgt een neutrale melding.
  //                      Geen redirect, geen herhaalpoging, geen opslag.
  const TRYOUT_VERVANGEN = window.smT(
    'sm.js.sm_cart_drawer.tryout_replaced',
    'Je vorige try-out- of kennismakingspakket is vervangen door dit pakket. Er past er één in een bestelling.',
  );
  const TRYOUT_CONTROLEER = window.smT('sm.js.sm_cart_drawer.tryout_check', 'Er past één try-out- of kennismakingspakket in een bestelling. Controleer je winkelwagen.');
  const verseWagen = () =>
    fetch(`${window.location.pathname}?section_id=${SECTIE}`)
      .then((r) => (r.ok ? r.text() : null))
      .catch(() => null);

  async function tryoutEnkel(houdKey) {
    let vervangen = false;
    try {
      const wagen = await (await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const regels = (wagen.items || []).filter(isTryout);
      // Zonder sleutel (opruimen bij het laden) blijft de nieuwste: /cart.js zet
      // de laatst toegevoegde regel bovenaan.
      const houd = regels.find((r) => r.key === houdKey) || regels[0];
      const updates = {};
      regels.forEach((r) => {
        if (r !== houd) updates[r.key] = 0;
        else if (r.quantity > 1) updates[r.key] = 1;
      });
      if (Object.keys(updates).length === 0) return null;
      vervangen = regels.length > 1;
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: SECTIE, sections_url: window.location.pathname }),
      });
      if (r.ok) {
        const html = (await r.json()).sections?.[SECTIE] || (await verseWagen());
        if (html) return { ok: true, html, vervangen };
      }
    } catch {}
    return { ok: false, html: await verseWagen(), vervangen };
  }

  // Weigerde /cart/add.js omdat er al een try-out in de wagen zit? Alleen dán
  // wisselen: een 422 om een andere reden (uitverkocht) mag de oude try-out niet
  // raken. Op de melding van de function (MELDING in
  // shopify-apps/sportmeals-checkout-guard/extensions/tryout-max-een/src/tryout.ts),
  // niet op "try-out": een voorraadfout noemt de producttitel ook (Codex 05-10).
  async function isTryoutWeigering(respons) {
    if (respons.status !== 422) return false;
    try {
      const fout = await respons.clone().json();
      // Oude tekst ("één try-outpakket") én nieuwe ("één try-out- of
      // kennismakingspakket"): thema en function gaan los live.
      return /één try-?out(pakket|- of kennismakingspakket) per bestelling/i.test(
        `${fout.message || ''} ${fout.description || ''}`,
      );
    } catch {
      return false;
    }
  }

  // Weigerde /cart/add.js omdat deze klant al eerder een try-out of
  // kennismakingspakket kocht (`meldingEerder` in de function: klanttag, of een
  // e-mailadres dat de wagen al kent)? Dan niet wisselen en geen native submit
  // (kale foutpagina), maar de melding in de la, met het gewone pakket van het
  // doel uit de melding. Geeft { tekst, link } of null.
  const KENN_COLLECTIES = {
    Afvallen: 'maaltijdpakketten-afvallen',
    Droogtrainen: 'maaltijdpakketten-droogtrainen',
    'Kracht & Herstel': 'maaltijdpakketten-kracht-herstel',
    Spiermassa: 'maaltijdpakketten-spiermassa',
  };
  async function kennEerderMelding(respons) {
    if (respons.status !== 422) return null;
    try {
      const fout = await respons.clone().json();
      const tekst = String(fout.description || fout.message || '');
      if (!/alleen bedoeld als eerste kennismaking/i.test(tekst)) return null;
      const doel = tekst.match(/van onze (.+?)-pakketten/)?.[1];
      const handle = doel && KENN_COLLECTIES[doel];
      return {
        tekst,
        link: handle
          ? { href: `${window.Shopify?.routes?.root || '/'}collections/${handle}`, label: window.smT('sm.js.sm_cart_drawer.view_goal_packages', 'Bekijk de {doel}-pakketten').replace('{doel}', doel) }
          : null,
      };
    } catch {
      return null;
    }
  }

  // Weigerde /cart/add.js omdat Simple Bundles een keuzepakket zonder keuzes ziet
  // (de app-selects nog niet geladen)? Zijn cart-validatie geeft dan een Engelse
  // 422 ("Please select bundle options for <titel>", gemeten 10-10; sinds 11-10 in
  // SB → Cart Validation op NL gezet: "Kies eerst je maaltijden voor <titel>."), en de
  // native submit zou die als kale foutpagina tonen. Geeft de NL-melding, of null.
  async function bundelKeuzeMelding(respons) {
    if (respons.status !== 422) return null;
    try {
      const fout = await respons.clone().json();
      const titel = String(fout.description || fout.message || '').match(/(?:select bundle options for|kies eerst je maaltijden voor) (.+?)\.?$/i)?.[1];
      if (!titel) return null;
      return window.smT('sm.js.sm_cart_drawer.choose_bundle_meals', 'Kies eerst je maaltijden voor {titel}. Je kiest ze op de productpagina.').replace('{titel}', titel.trim());
    } catch {
      return null;
    }
  }

  // Eerst weg, dan toe. Geeft de Response van de geslaagde toevoeging terug, of
  // null — en dan staat de oude try-out er weer (de nieuwste, aantal 1).
  async function tryoutWisselen(data, form) {
    let oud;
    // Het "Wijzigen"-merkteken blijft staan tot de wissel geslaagd is; bij
    // terugzetten krijgt het de nieuwe regelsleutels (Codex 11-10).
    let merk = null;
    try {
      const wagen = await (await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      oud = (wagen.items || []).filter(isTryout);
      // Een uitgeklapt try-outpakket heeft geen try-out-handle: zijn regels
      // zijn maaltijden met `_sb_bundle_*`. Kwam de klant via "Wijzigen" hier,
      // dan zijn díé regels het oude pakket (Codex 11-10).
      if (oud.length === 0) {
        const v = bundelVervangVoor(form);
        if (v) {
          oud = (wagen.items || []).filter((i) => v.keys.includes(i.key));
          if (oud.length) merk = v;
        }
      }
    } catch {
      return null;
    }
    if (oud.length === 0) return null;
    try {
      const weg = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: Object.fromEntries(oud.map((r) => [r.key, 0])) }),
      });
      if (!weg.ok) return null;
    } catch {
      // Antwoord weg, maar het weghalen kan gelukt zijn. Gewoon doorgaan: stond
      // de oude er nog, dan weigert de validatie de toevoeging en het
      // terugzetten, en blijft alles zoals het was (Codex 05-10).
    }
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      if (r.ok) {
        if (merk) sessionStorage.removeItem(BUNDEL_VERVANG);
        return r;
      }
    } catch {}
    // Terugzetten. Was de toevoeging tóch geland (antwoord onderweg weg), dan
    // weigert de validatie dit en blijft alleen de nieuwe staan — ook goed.
    // Een try-out-ouderregel gaat terug als één stuk; uitgeklapte pakketregels
    // allemaal, met hun eigen aantal en eigenschappen.
    const terugRegels = isTryout(oud[0]) ? [oud[0]] : oud;
    const items = terugRegels.map((terug) => {
      const item = { id: terug.variant_id, quantity: isTryout(terug) ? 1 : terug.quantity, properties: terug.properties || {} };
      if (terug.selling_plan_allocation) item.selling_plan = terug.selling_plan_allocation.selling_plan.id;
      return item;
    });
    try {
      const terug = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (merk && terug.ok) {
        const keys = ((await terug.json()).items || []).map((i) => i.key);
        if (keys.length) sessionStorage.setItem(BUNDEL_VERVANG, JSON.stringify({ ...merk, keys }));
      }
    } catch {}
    return null;
  }

  const tryoutTekst = (enkel) =>
    !enkel ? '' : enkel.ok ? (enkel.vervangen ? TRYOUT_VERVANGEN : '') : TRYOUT_CONTROLEER;

  // In de toast, in het live-gebied, en bovenin de wagen (zichtbaar op /cart en
  // zodra de la opengaat). Ná `verversen()` aanroepen: die vervangt de wagen.
  // `link` ({ href, label }) is optioneel; zonder link krijgt alleen
  // TRYOUT_CONTROLEER er een (naar de wagen).
  function tryoutMelden(tekst, link = null) {
    const noot = document.querySelector('[data-cart-toast-noot]');
    if (noot) {
      noot.textContent = tekst;
      noot.hidden = !tekst;
    }
    if (!tekst) return;
    document.querySelectorAll('[data-cart-melding]').forEach((el) => {
      el.textContent = (el.textContent ? el.textContent + ' ' : '') + tekst;
    });
    const binnen = document.querySelector('[data-cart-inner]');
    if (!binnen) return;
    binnen.querySelector('.cd-tryout-noot')?.remove();
    if (!link && tekst === TRYOUT_CONTROLEER) {
      link = { href: (window.Shopify?.routes?.root || '/') + 'cart', label: window.smT('sm.js.sm_cart_drawer.to_cart', 'Naar je winkelwagen') };
    }
    const p = document.createElement('p');
    p.className = 'cd-tryout-noot';
    p.textContent = tekst + ' ';
    if (link) {
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      p.append(a);
    }
    binnen.prepend(p);
  }

  // Een geweigerde toevoeging melden waar de klant kijkt. Met la: la open, melding
  // erin. Zonder la (instelling "wagenpagina": het paneel is `hidden`, er is geen
  // dialog) opent `openen()` niets en staat de melding in een onzichtbaar paneel —
  // dan óók een melding direct onder de koopknop (Codex 06-10). Op /cart is het
  // paneel de pagina zelf en volstaat de melding erin.
  function meldZichtbaar(form, tekst, link = null) {
    openen();
    tryoutMelden(tekst, link);
    if (drawer() || !document.querySelector('[data-cart-inner]')?.closest('[hidden]')) return;
    form.parentElement?.querySelector(':scope > [data-tryout-los]')?.remove();
    if (!link && tekst === TRYOUT_CONTROLEER) {
      link = { href: (window.Shopify?.routes?.root || '/') + 'cart', label: window.smT('sm.js.sm_cart_drawer.to_cart', 'Naar je winkelwagen') };
    }
    const p = document.createElement('p');
    p.className = 'cd-tryout-noot';
    p.setAttribute('data-tryout-los', '');
    p.setAttribute('role', 'alert');
    p.textContent = tekst + ' ';
    if (link) {
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      p.append(a);
    }
    form.after(p);
  }

  // Na DOMContentLoaded: de gebundelde scripts laden vóór de sectie-HTML, dan
  // bestaat `[data-cart-root]` nog niet. Eén poging per paginalading.
  const tryoutOpruimen = () => {
    if (!root()?.hasAttribute('data-tryout-teveel')) return;
    inWachtrij(async () => {
      const enkel = await tryoutEnkel(null);
      if (enkel?.html) verversen(enkel.html);
      tryoutMelden(tryoutTekst(enkel));
    });
  };
  // "Opnieuw kopen" op een try-out in het klantaccount linkt naar /cart/<try-out>:1?…&sso=silent;
  // Shopify stuurt die stil door naar een kale / met een lege wagen. Gemeten 11-10 met de
  // echte knop: verwijzer account.sportmeals.com, geen query, redirectCount 0 (de SSO-hop
  // is cross-origin). "Winkel" en het logo in het account landen op /?country=NL en vallen
  // dus af; een oude URL-redirect of kortingslink heeft geen account als verwijzer. Alleen
  // voor een ingelogde klant met een `kennismaking-*`-tag: alleen die kan een try-out
  // opnieuw kopen. Herladen of terug telt niet.
  // shortcut: zonder la (instelling "wagenpagina") geen melding — er is dan niets zichtbaars om te openen.
  const tryoutHerbestelMelden = () => {
    if (!drawer() || !root()?.hasAttribute('data-kennismaking-klant')) return;
    if (location.pathname !== (window.Shopify?.routes?.root || '/') || location.search) return;
    if (performance.getEntriesByType('navigation')[0]?.type !== 'navigate') return;
    let van = '';
    try { van = new URL(document.referrer).hostname; } catch { return; }
    if (!/(^|\.)shopify\.com$|^account\./.test(van)) return;
    openen();
    tryoutMelden(window.smT('sm.js.sm_cart_drawer.tryout_rebuy', 'Een try-out bestel je één keer. Je kunt dezelfde maaltijden los bestellen of een pakket kiezen.'));
  };
  const bijLaden = () => {
    tryoutOpruimen();
    // Microtask: `openen()` leest `toast`, die verderop pas gedeclareerd wordt (TDZ).
    queueMicrotask(tryoutHerbestelMelden);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bijLaden, { once: true });
  } else {
    bijLaden();
  }

  function openen() {
    const d = drawer();
    // Focus wég uit de melding vóór `showModal()`, niet erna. Het dialog onthoudt
    // op dát moment welk element de focus had en zet hem daar bij het sluiten
    // terug. Werd de la geopend vanaf de knop ín de melding, dan is dat element
    // één regel later `display: none` en doet die terugzetstap niets: de focus
    // valt op body en de volgende Tab begint bovenaan de pagina. Precies de
    // storing waar `focusTerug` hieronder voor de steppers voor bestaat.
    // Onvoorwaardelijk verplaatsen als de melding openstaat, niet alleen wanneer
    // de focus er aantoonbaar ín staat. Safari verplaatst de focus namelijk niet
    // naar een <a> bij een klik — zie de comment bij `toastFocusuit` hieronder —
    // dus daar is `activeElement` nog <body> en zou een `contains`-toets nee
    // zeggen terwijl de la wél vanuit de melding geopend wordt. `showModal()`
    // legt dan <body> vast als terugkeerpunt en de focus valt na het sluiten
    // alsnog op body.
    const t = toast();
    if (t && !t.hidden) document.querySelector('[data-cart-link]')?.focus();
    if (d && !d.open) {
      d.showModal();
      ladeGezien();
    }
    // De melding heeft zijn werk gedaan zodra de la opengaat; laten staan zou hem
    // achter de backdrop parkeren en na het sluiten weer tevoorschijn laten komen.
    toastVerbergen();
    feedInhalen();
  }

  // Meting (PostHog 11-10): één event per opening van de la, met de stand die de
  // klant op dat moment ziet. Alleen als PostHog er is (consent); nooit een fout.
  function ladeGezien() {
    try {
      if (typeof window.posthog?.capture !== 'function') return;
      const bron = document.querySelector('[data-cart-inner] [data-cart-tekort]');
      if (!bron) return;
      const afreken = document.querySelector('#cd-form [name="checkout"]');
      const verder = document.querySelector('[data-cart-inner] .cd-naar-pakketten');
      const maaltijden = Number(bron.dataset.cartMaaltijden || 0);
      let knop = 'geen';
      if (afreken) knop = afreken.disabled ? 'afrekenen_dicht' : 'afrekenen';
      else if (verder) knop = maaltijden > 0 ? 'meer_maaltijden' : 'bekijk_pakketten';
      window.posthog.capture('cart_drawer_viewed', {
        meals: maaltijden,
        minimum_reached: Number(bron.dataset.cartTekort || 0) === 0 && maaltijden > 0,
        total: Number(bron.dataset.cartTotaalCent || 0) / 100,
        primary_button: knop,
      });
    } catch {}
  }

  // De toevoegmelding bij het wagenicoon. De markup staat in `sm-header.liquid`,
  // want hij moet blijven staan terwijl de drawer dicht is; hier staat alleen het
  // vullen en het wegnemen. Ontbreekt hij — een pagina zonder header — dan doet
  // dit niets en gaat de rest gewoon door.
  const toast = () => document.querySelector('[data-cart-toast]');
  let toastKlok;

  // Kwam de laatste bediening van een toetsenbord? Bepaalt of de melding de focus
  // naar zich toe haalt.
  //
  // Waarom dat onderscheid nodig is: het paneel staat in de header en dus vroeg in
  // de DOM. Wie op een productkaart iets toevoegt en vooruit tabt, komt er nooit
  // meer langs — de bevestiging én de knop erin zijn alleen achteruit bereikbaar.
  // Focus verplaatsen lost dat op, maar mag niet altijd: bij een muisklik zou de
  // focus in het paneel blijven staan, en dan houdt de bestaande focusout-tak de
  // melding open tot de klant ergens anders klikt. Wat een klok van 6 seconden was,
  // wordt dan een paneel dat blijft hangen.
  let viaToetsenbord = false;
  document.addEventListener('pointerdown', () => { viaToetsenbord = false; }, true);
  document.addEventListener('keydown', (e) => {
    // Alleen de toetsen die een knop of formulier bedienen. Tabben alleen is
    // navigeren, geen bediening.
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') viaToetsenbord = true;
  }, true);

  // Escape sluit de melding. Hij hangt op het document en niet op het paneel: bij
  // een muistoevoeging staat de focus nog op de toevoegknop, dus een luisteraar op
  // het paneel zelf zou de toets nooit zien.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const t = toast();
    if (!t || t.hidden) return;
    // Stond de focus in het paneel, dan moet hij ergens heen dat bestaat. `body`
    // is geen plek; de wagenknop is waar het paneel bij hoort en is altijd zichtbaar.
    const focusBinnen = t.contains(document.activeElement);
    toastVerbergen();
    if (focusBinnen) toastFocusTerug();
  });

  // De sluitknop. Gedelegeerd, want het paneel wordt niet opnieuw gerenderd maar de
  // luisteraar mag ook niet per toevoeging opnieuw gebonden worden.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-cart-toast-sluit]')) return;
    toastVerbergen();
    toastFocusTerug();
  });

  // "Afrekenen" in de melding. Geen eigen weg naar de checkout: hij verstuurt
  // `#cd-form` met de afrekenknop van de la als verzender, en loopt daarmee door
  // precies dezelfde submit-handler als die knop — cadeau-sync, fail-closed,
  // `cdAfrekenen` (zie verderop). `requestSubmit` en niet `submit()`: alleen de
  // eerste vuurt het submit-event.
  //
  // ⚠ `requestSubmit` toetst niet of de verzender `disabled` is. Die toets doen
  // we zelf, want dicht betekent hier iets: onder de minimumafname, of een aantal
  // dat nog onderweg is (`qtyPlannen`). Dan gaat de la open, die zegt waarom — en
  // in de stille vorm, zonder la, de wagenpagina.
  const toastAfrekenKnop = () => document.querySelector('#cd-form [name="checkout"]');
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-toast-afrekenen]')) return;
    const knop = toastAfrekenKnop();
    // Ook terug naar de la als er nog een toevoeging in de rij staat (`bezig`):
    // dan is de la-DOM nog niet de wagen van ná die toevoeging. En als de browser
    // `requestSubmit` niet kent (Safari onder 16): `submit()` slaat de handler
    // over, dus dan niet stil niets doen maar de la, die zelf afrekent.
    // ⚠ Op dit pad verbergt `openen()` de melding zelf, ná de focusoverdracht.
    // Eerst verbergen sloeg die over (`!t.hidden` is dan al onwaar): de focus
    // viel na het sluiten van de la op body (Codex P2, 03-10).
    if (!knop || knop.disabled || bezig || typeof knop.form?.requestSubmit !== 'function') {
      if (drawer()) {
        openen();
      } else {
        toastVerbergen();
        naarWagen();
      }
      return;
    }
    toastVerbergen();
    knop.form.requestSubmit(knop);
  });
  // De `focusout`-luisteraar wordt bewaard in plaats van alleen met `once`
  // afgevuurd. Zonder dat blijft hij hangen: staat de focus in het paneel als de
  // klok afloopt, dan wordt hij gewapend, maar sluit de klant het paneel niet en
  // voegt hij iets nieuws toe, dan staat er een verse melding mét een oude
  // luisteraar — en die neemt hem bij de eerstvolgende focuswissel meteen weg.
  // In Safari verplaatst een klik op een knop de focus niet, dus daar is dat een
  // gewone volgorde en geen randgeval.
  let toastFocusuit = null;

  /**
   * Geeft de focus terug aan de wagenknop nadat de melding gesloten is.
   *
   * ⚠ OPEN PUNT, bewust niet verder opgerekt. De code-review merkte terecht op
   * dat de conventionele stand is: terug naar de knop die de melding opriep, niet
   * naar de header. Op een collectiepagina gooit dit een toetsenbordwinkelaar
   * terug naar boven.
   *
   * Twee pogingen daartoe zijn GEMETEN en werkten geen van beide. Het formulier
   * bij de submit vastleggen (de knop zelf kan niet: `toevoegen()` zet hem op
   * `disabled` en dát verplaatst de focus naar `body` vóórdat de melding
   * verschijnt) en daarna zijn submitknop focussen liet de focus op `body`
   * achter — óók met de `focus()` een frame later, ná het `hidden` zetten van het
   * paneel. Beide takken van die functie hadden iets moeten focussen; geen van
   * beide landde. Onopgelost.
   *
   * Wat hieronder staat is de variant die WÉL gemeten werkt. Een werkende
   * eenvoudige stand is beter dan een kapotte betere; wie hem alsnog wil
   * oprekken, begint bij de vraag waaróm die focus niet landt en meet dat vóór
   * hij code toevoegt.
   */
  function toastFocusTerug() {
    document.querySelector('[data-cart-open]')?.focus();
  }

  function toastKlokWissen() {
    clearTimeout(toastKlok);
    const t = toast();
    if (t && toastFocusuit) t.removeEventListener('focusout', toastFocusuit);
    toastFocusuit = null;
  }

  function toastVerbergen() {
    const t = toast();
    if (t) t.hidden = true;
    toastKlokWissen();
  }

  // `bijwerken`: de stepper ververst een open melding; de focus blijft dan op de stepper.
  function toastTonen(regel, bijwerken) {
    const t = toast();
    if (!t) return;
    const naam = t.querySelector('[data-cart-toast-naam]');
    // `product_title` is het veld dat /cart/add.js teruggeeft, ook in de
    // `items`-vorm. Ontbreekt het, dan blijft de naamregel leeg en klapt hij via
    // `:empty` weg.
    //
    // ⚠ Sinds de melding het vinkje "Toegevoegd" én de knop kwijt is, blijft er in
    // dat geval alleen een foto, een aantal en een prijs over — nergens meer een
    // woord dat zégt dat er iets is toegevoegd. De aankondiging op
    // `[data-cart-melding]` vangt dat op voor een schermlezer, maar zichtbaar is
    // het een stille kaart. Gemeten: /cart/add.js gaf op alle geteste routes een
    // product_title, dus dit is een randgeval en geen dagelijkse stand.
    // Zonder `regel` (de stepper bracht hem naar nul) blijft het gerecht staan.
    if (naam && regel) naam.textContent = regel.product_title || '';

    // Prijs, wagenstand en voortgang. Die worden hier NIET uitgerekend: de
    // drawer-sectie is vlak hiervoor door `verversen()` opnieuw gerenderd en
    // draagt exact dezelfde cijfers, in het money_format van de winkel en in de
    // copy van dit thema. Ze hier overtypen zou een tweede bron maken die stil
    // uiteenloopt zodra de staffel of de drempeltekst wijzigt.
    const uitDrawer = (kies) => document.querySelector(kies)?.textContent.trim() || '';

    const prijs = t.querySelector('[data-cart-toast-prijs]');
    // `final_line_price` is de regel inclusief aantal; bij een dubbele toevoeging
    // van hetzelfde gerecht is dat de hele regel en niet alleen wat er net bij
    // kwam. In centen, dus door 100 — het valutateken komt uit de wagen zelf.
    if (prijs && regel) {
      const cent = regel && (regel.final_line_price ?? regel.line_price ?? regel.final_price);
      prijs.textContent = typeof cent === 'number' ? '€' + (cent / 100).toFixed(2).replace('.', /^en/i.test(document.documentElement.lang) ? '.' : ',') : '';
    }

    const stand = t.querySelector('[data-cart-toast-stand]');
    if (stand) {
      const wortel = document.querySelector('[data-cart-root]');
      const aantal = Number(wortel?.dataset.cartCount || 0);
      // `data-cart-totaal` en niet de eerste voetregel: die draagt het subtotaal
      // vóór een wagenbrede korting, en dan noemde de melding een hoger bedrag
      // dan de afrekenknop.
      const totaal = wortel?.dataset.cartTotaal || '';
      // Het woord "totaal" stond hier omdat bij één gerecht regelprijs en
      // wagentotaal hetzelfde bedrag zijn, en twee gelijke bedragen naast elkaar
      // als een fout lezen. Dat geldt nog steeds — maar alleen dán. Vanaf twee
      // artikelen verschillen de bedragen zichtbaar en is het woord ballast op een
      // regel die in één oogopslag gelezen moet worden.
      stand.textContent = aantal
        ? aantal + (aantal === 1 ? window.smT('sm.js.sm_cart_drawer.item_one', ' artikel') : window.smT('sm.js.sm_cart_drawer.item_other', ' artikelen')) +
          (totaal ? (aantal === 1 ? window.smT('sm.js.sm_cart_drawer.total_sep', ' · totaal ') : ' · ') + totaal : '')
        : '';
    }

    // ⚠ Hier stond de voortgangsregel (maaltijddrempel of verzendstaffel). Die is
    // eruit: exact dezelfde zin staat in de wagenla, en de melding is een
    // bevestiging van één handeling — niet een tweede plek waar de staffel wordt
    // uitgelegd. Het blauwe wash-vlak eronder maakte de melding bovendien bijna
    // twee keer zo hoog voor informatie die je een klik verderop nog een keer ziet.
    // De la blijft de plek waar de staffel woont.

    // "Afrekenen" alleen als de afrekenknop in de la ook open staat — anders
    // belooft de melding iets wat de la weigert. De la is vlak hiervoor ververst,
    // dus dit is de stand van ná de toevoeging.
    const afreken = t.querySelector('[data-toast-afrekenen]');
    if (afreken) {
      const knop = toastAfrekenKnop();
      afreken.hidden = !knop || knop.disabled;
    }
    // Joey 07-10: onder de minimumafname de dichte knop van de la, maar als
    // link naar meer maaltijden — dezelfde tekst, hetzelfde tekort en dezelfde
    // bestemming als `.cd-naar-pakketten`, uit de zojuist ververste la-inhoud.
    const verder = t.querySelector('[data-toast-verder]');
    if (verder) {
      const bron = document.querySelector('[data-cart-inner] [data-cart-tekort]');
      const tekort = Number(bron?.dataset.cartTekort || 0);
      verder.hidden = !(tekort > 0 && bron.dataset.cartVerderUrl);
      if (!verder.hidden) {
        verder.href = bron.dataset.cartVerderUrl;
        verder.querySelector('[data-toast-verder-tekst]').textContent = bron.dataset.cartVerderLabel || '';
      }
    }

    // Het beeld komt uit dezelfde respons. `image` is de kale CDN-URL; daar een
    // `width` op zetten scheelt een bestand van een megabyte voor een vak van
    // 46px. 138 = 3× 46, voor een scherm op 3x. Markup, CSS en deze breedte
    // moeten hetzelfde vak beschrijven; ze liepen twee keer eerder uiteen. Ontbreekt het beeld, dan haalt `removeAttribute` het `src` weg en
    // klapt het kader via `:not([src])` weg in plaats van leeg te blijven staan.
    const beeld = t.querySelector('[data-cart-toast-beeld]');
    if (beeld && regel) {
      const bron = (regel && (regel.image || regel.featured_image?.url)) || null;
      if (bron) beeld.src = bron + (bron.includes('?') ? '&' : '?') + 'width=138';
      else beeld.removeAttribute('src');
    }

    // Stond de melding er al, dan is `hidden = false` een no-op en speelt de
    // animatie niet opnieuw: naam en foto wisselen dan geruisloos. Nu de drawer
    // niet meer openklapt is dit paneel de énige bevestiging, dus een stille
    // wissel is makkelijk te missen. De animatienaam even weghalen en een reflow
    // forceren start hem opnieuw; `offsetWidth` uitlezen ís die reflow.
    if (!t.hidden) {
      t.style.animation = 'none';
      void t.offsetWidth;
      t.style.animation = '';
    }
    t.hidden = false;

    // Alleen bij een toetsenbordtoevoeging: zie `viaToetsenbord` hierboven. De
    // focus gaat naar het paneel zelf en niet naar de sluitknop — dan leest een
    // schermlezer eerst het label en de inhoud, in plaats van meteen "Melding
    // sluiten" zonder te zeggen wát er gesloten wordt.
    if (viaToetsenbord && !bijwerken) t.focus({ preventScroll: true });

    toastKlokWissen();
    toastKlok = setTimeout(() => {
      // Niet wegnemen terwijl de focus erbinnen staat: dan verliest een
      // toetsenbordgebruiker halverwege zijn plek en springt de focus naar body.
      // Wachten tot hij eruit stapt is de enige stand die dat niet doet.
      if (t.contains(document.activeElement)) {
        toastFocusuit = () => { t.hidden = true; toastFocusuit = null; };
        t.addEventListener('focusout', toastFocusuit, { once: true });
        return;
      }
      t.hidden = true;
    }, 6000);
  }

  // Inhaalslag voor de cross-sell-feed; zie punt 4 bij de feed in de Liquid
  // hierboven. De feed staat in een `paginate`-blok, en dat luistert naar `?page`
  // in de URL. Op /collections/x?page=2 rendert hij daardoor uit een tweede pagina
  // die niet bestaat en staat hij leeg. Elke wagenmutatie herstelt dat vanzelf
  // (`sections_url` is `location.pathname`, dus zonder query), maar wie de la
  // opent zónder iets te wijzigen zou een lege feed zien.
  //
  // Het baken zit ín `[data-cart-inner]` en niet erop: `verversen` vervangt de
  // binnenkant, dus het verdwijnt vanzelf zodra de verse sectie binnen is. Een
  // vlag op het element eromheen zou blijven staan en elke opening opnieuw vuren.
  // `bezigInhalen` dekt alleen de tijd dat het verzoek loopt — mislukt het, dan
  // mag een volgende opening het opnieuw proberen.
  let bezigInhalen = false;
  function feedInhalen() {
    if (bezigInhalen) return;
    if (!document.querySelector('[data-feed-vervolg]')) return;
    bezigInhalen = true;
    fetch(`${window.location.pathname}?section_id=${SECTIE}`)
      .then((r) => (r.ok ? r.text() : null))
      .then((html) => {
        // Nog eens toetsen, en dat is geen dubbelop: deze fetch kan landen ná
        // een wagenmutatie die intussen door de rij liep. Ging er zo'n mutatie
        // doorheen, dan is het baken al weg en zou deze — oudere — momentopname
        // de verse wagen overschrijven. (Hier stond dat `openen()` óók vlak vóór
        // een toevoeging draaide; dat is niet meer zo, maar de toets blijft
        // nodig.)
        if (html && document.querySelector('[data-feed-vervolg]')) verversen(html);
      })
      .catch(() => {})
      .finally(() => {
        bezigInhalen = false;
      });
  }

  // Zet de focus terug op de knop waar hij vandaan kwam. Nodig om twee redenen
  // die allebei op zichzelf al genoeg zijn: het uitschakelen van de knop blurt
  // hem, en de vervanging hieronder gooit hem daarna weg. Zonder dit valt een
  // toetsenbordgebruiker na élke plus terug op het dialog en moet hij opnieuw
  // tabben — per stuk.
  // De zoektocht is begrensd tot de drawerinhoud, en dat is geen detail: dezelfde
  // `data-key` staat óók op de stepper van de productkaart. Een ongebonden
  // querySelector pakt die eerst, en zolang het dialog modaal is, is alles
  // daarbuiten inert — focus() doet dan niets en de focus blijft op body hangen.
  function focusTerug(knop, inDrawer, key, stap) {
    // `stap` is het `data-step`-attribuut van de knop, of de tekst 'veld' voor het
    // invoerveld met het aantal. Sinds 25-08-2026 wordt deze niet meer vanuit de
    // klik aangeroepen maar vanuit `verversen`: de schrijfronde is losgekoppeld
    // van de klik, dus het element waar de focus op stond is dan al vervangen.
    if (!inDrawer) {
      // Buiten de drawer wordt niets vervangen, dus de oorspronkelijke knop
      // bestaat nog — maar bestaan is niet genoeg. Ging het aantal naar nul, dan
      // is de hele stepper op de kaart intussen `display: none` en doet focus()
      // niets; de focus valt dan terug op body en de volgende Tab begint weer
      // bovenaan de pagina. De koopknop staat op diezelfde plek terug.
      // `preventScroll`: het element staat na het scrollherstel hierboven weer op
      // zijn eigen plek, dus focus() hoeft er niet naartoe te springen — en dóét
      // hij dat wel, dan is de sprong terug van precies dezelfde orde als de
      // sprong die we net weggenomen hebben.
      if (knop.offsetParent) knop.focus({ preventScroll: true });
      else
        knop
          .closest('[data-card-atc]')
          ?.querySelector('[type="submit"]')
          ?.focus({ preventScroll: true });
      return;
    }
    // Of de knop in de drawer stond moet vooraf zijn vastgesteld: ná de
    // vervanging is het oorspronkelijke element losgekoppeld, en dan zegt elke
    // `contains`-toets nee — waarna focus() op een dood element niets doet.
    const inner = document.querySelector('[data-cart-inner]');
    const terug =
      stap === 'veld'
        ? inner.querySelector(`[data-stepper][data-key="${key}"] [data-step-value]`)
        : inner.querySelector(
            `[data-stepper][data-key="${key}"] [data-step="${stap}"]:not([disabled])`
          );
    // Ging het aantal naar nul, dan bestaat die knop niet meer; dan is de
    // sluitknop de eerstvolgende zinnige plek in plaats van helemaal geen focus.
    if (terug) terug.focus({ preventScroll: true });
    else document.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
  }

  // De sectie komt terug als volledige HTML. Alleen de binnenkant wordt
  // vervangen: het dialog-element blijft daardoor staan en dus open.
  // Geeft terug of het gelukt is. Kwam de sectie niet mee, dan toont de drawer de
  // wagen van vóór de wijziging en leest dat als "er is niets gebeurd" — waarna de
  // klant nog een keer drukt. De aanroeper stuurt in dat geval door naar /cart,
  // waar de waarheid staat.
  /* De énige plek die cadeau-attributen naar de wagen schrijft. Ze hangen ook via
   * `form="cd-form"` aan het afrekenformulier, maar dat pad loopt alleen als de klant
   * via de drawer afrekent — niet vanaf /cart en niet met een betaalknop. Deze functie
   * schrijft ze daarom actief weg: bij het laden, na elke verversing, en na een
   * cadeaukeuze. Faalt de POST, dan blijft `cd-form` het vangnet.
   *
   * ⚠ Er stond hier tot 22-08-2026 een tweede schrijver: de `change`-luisteraar op de
   * radio's postte zijn eigen keuze rechtstreeks, buiten `cadeauStand` om. Twee
   * schrijvers en één cache is een gat: na zo'n keuze week de cache af van de wagen,
   * en zakte de klant daarna onder de drempel, dan zag deze functie "al geschreven" en
   * sloeg het wissen over — een onverdiend cadeau op de order. Voeg er dus geen tweede
   * schrijfpad bij; laat elke aanleiding hier binnenkomen. */
  let cadeauStand = null;
  let cadeauBezig = false;
  let cadeauWachtend = null;

  /* Eén verzoek tegelijk, en hoogstens één wachtende — de nieuwste. Niet een ketting
   * die alles achter elkaar afwerkt: elke POST draagt de vólledige stand, dus een
   * tussenliggende is per definitie achterhaald, en een rij van drie zou de laatste
   * (meestal de opruimstand) drie retourtijden laten wachten. Zo is de vertraging
   * hoogstens één retour, ongeacht hoe snel er geklikt wordt.
   *
   * `keepalive` laat een lopend verzoek de paginanavigatie overleven — nodig omdat
   * `/cart` de cadeautredes helemaal niet rendert en er daar dus geen `cd-form`-vangnet
   * is; wie vanaf de la doorklikt naar /cart en afrekent, leunt volledig op deze POST.
   *
   * ⚠ Eén geval blijft onbepaald: navigeren terwijl er een oudere POST loopt én er een
   * nieuwere stand klaarstaat. `pagehide` stuurt die nieuwere dan alsnog, maar welke van
   * de twee als laatste bij Shopify landt is niet te sturen. Dat is niet erg meer sinds
   * `sections/cart.liquid` een cadeau dat de drempel niet haalt zelf uit het
   * afrekenformulier wist — de weg naar de checkout repareert zichzelf dus. Wat er
   * overblijft zijn de versnelde betaalknoppen, die het formulier overslaan — en díé
   * zijn sinds 25-08-2026 gedekt door `cadeauRegelsSyncen()` hieronder: het cadeau is
   * dan een echte wagenregel, en een wagenregel slaat geen betaalknop over.
   * Zie de notitie bovenaan `snippets/sm-cadeau-tredes.liquid`. */
  /* Ook deze schrijfronde is een belofte, en om dezelfde reden als
   * `regelsLopend`: het cart attribute is de leesbare vorm op de order waar
   * fulfilment op werkt. De hidden inputs in het cart-formulier op de
   * wagenpagina waren het vangnet, maar die post niemand meer — de afrekenknop
   * doet `preventDefault()` en navigeert zelf. Bleef dit vuur-en-vergeet, dan
   * kon een oude "Cadeau vanaf €75" alsnog op de order landen.
   *
   * ⚠ Schrijf hierboven geen letterlijke Liquid-tag: dit blok staat in het
   * Liquid-bestand, dus een `{`+`% form %`+`}` in een JS-commentaar wordt gewoon
   * geparseerd en levert "LiquidTag 'form' was closed". */
  let cadeauLopend = null;

  function cadeauVersturen() {
    if (cadeauBezig) return cadeauLopend || Promise.resolve();
    if (!cadeauWachtend) return Promise.resolve();
    cadeauBezig = true;
    cadeauLopend = (async () => {
      try {
        // Een lus en géén staartaanroep. `.then(() => cadeauVersturen())` gaf een
        // "chaining cycle": als er niets meer wachtte gaf die aanroep `cadeauLopend`
        // terug — de belofte die op dat moment zélf werd opgelost. De lus haalt
        // ingehaalde standen net zo goed op en kan zichzelf niet oplossen.
        // `mislukt` geldt voor de láátste stand: een latere geslaagde POST draagt
        // de volledige stand en maakt een eerdere fout ongedaan.
        let mislukt = false;
        while (cadeauWachtend) {
          const attributes = cadeauWachtend;
          cadeauWachtend = null;
          // Een 429 of 422 is een geslaagde fetch en zou anders stil verdwijnen. Voor
          // afrekenen vanaf /cart of met een betaalknop bestaat geen vangnet — `cd-form`
          // dekt alleen de drawer — dus de stand moet opnieuw geprobeerd kunnen worden.
          // En sinds 11-10 (Codex) faalt de belofte: de afrekenknop wacht hierop en
          // mag dan niet doorsturen.
          mislukt = !(await wagenPost('cart/update.js', { attributes }, true));
          if (mislukt) cadeauStand = null;
        }
        if (mislukt) throw new Error('cadeau-attributen niet geschreven');
      } finally {
        cadeauBezig = false;
      }
    })();
    return cadeauLopend;
  }

  // Verlaat de klant de pagina met een stand die nog niet weg is, dan gaat hij hier
  // alsnog mee — óók als er nog een oudere POST loopt. Die twee kunnen dan in
  // willekeurige volgorde landen, en dat is bewust de minst slechte keuze: hem
  // wéglaten betekent gegarandeerd de oude stand, hem sturen betekent een kans op de
  // juiste. En sinds `sections/cart.liquid` een niet-verdiend cadeau zelf uit het
  // afrekenformulier wist, repareert de weg naar de checkout zich daarna alsnog.
  // `pagehide` en niet `beforeunload`: dat laatste vuurt niet op mobiel Safari.
  window.addEventListener('pagehide', () => {
    cadeauBezig = false;
    cadeauVersturen().catch(() => {});
  });

  function cadeausSchrijven() {
    cadeauAttributenPlannen();
    // Buiten de ongewijzigd-toets: het attribuut kan al kloppen terwijl de regel
    // ontbreekt — bij een verse paginalading is `cadeauStand` leeg maar staat de
    // wagen er al, en na een mislukte toevoeging verandert de stand niet.
    // Vuur-en-vergeet hier; wie moet wachten (de afrekenknop) pakt `regelsLopend`.
    cadeauRegelsSyncen().catch(() => {});
  }

  function cadeauAttributenPlannen() {
    // Alles met een stempel telt mee: de verborgen velden van een trede met één cadeau,
    // de lege opruimvelden van een trede die níét gehaald wordt, én de aangevinkte radio
    // van een trede met twee. Dat maakt dit de vólledige stand in plaats van alleen wat
    // gehaald is — anders schrijft hij wel en wist hij nooit.
    //
    // Een niet-aangevinkte radio overslaan en niet als lege waarde meesturen: allebei de
    // radio's van één trede dragen dezelfde sleutel, dus wie ze alle twee wegschrijft
    // laat de laatste de keuze van de klant overschrijven.
    const attributes = {};
    document.querySelectorAll('[data-cadeau]').forEach((v) => {
      if (v.type === 'radio' && !v.checked) return;
      attributes[v.dataset.cadeau] = v.value;
    });

    // Niet posten als er niets te melden valt, en niet opnieuw posten als de stand
    // ongewijzigd is. Zonder deze twee ging er bij élke verversing een tweede
    // cart-request mee, terwijl de omliggende code mutaties juist serialiseert.
    const stand = JSON.stringify(attributes);
    if (stand !== '{}' && stand !== cadeauStand) {
      cadeauStand = stand;

      // Nieuwste stand wint. Stond er al een te wachten, dan was die achterhaald —
      // hij wordt hier overschreven en niet in een rij gezet.
      cadeauWachtend = attributes;
      cadeauVersturen().catch(() => {});
    }
  }

  /* Het cadeau als échte wagenregel van € 0.
   *
   * De Shopify Function achter "Tiered Gifts - 100% Korting" prijst elke regel met
   * property `_tiered_gift: "true"` voor 100% af. Hij telt zelf niets: geen drempel,
   * geen productlijst. Wie een cadeau verdient wordt hier bepaald — dezelfde stempels
   * die het cart attribute schrijven, dus de twee kunnen niet uiteenlopen.
   *
   * Tredes stapelen vanzelf: bij 21 maaltijden staan de tredes 12, 18 én 21 aan en
   * levert dit drie regels op. Dat is precies de 12+1 / 18+2 / 21+3 uit de campagne,
   * zonder dat er ergens een aantal geconfigureerd hoeft te worden.
   *
   * ⚠ De poort staat alléén hier. De Function prijst élke regel met dat stempel af,
   * ook een pakket van € 221,30 dat iemand er met een eigen `/cart/add.js` in zet.
   * Dat gat bestaat sinds 22-02-2026 en is bewust geaccepteerd (25-08-2026); het
   * dichten vraagt een nieuwe deploy van de function met de drempel in zijn eigen
   * configuratie-metafield. Zie `sportmeals/marketing/septembercampagne-2026/OPENSTAAND.md`.
   */
  /* De keuze van de klant is de waarheid tot de server hem bevestigt.
   *
   * Zonder deze twee kaarten verloor snel wisselen: `verversen` vervangt de
   * binnenkant van de la met de sectie zoals de sérver hem kent, en die kende de
   * verse klik nog niet — de radio sprong terug en een openstaande trede klapte
   * dicht. De volgende sync las dan die teruggesprongen stand als "gewenst" en
   * zette het oude cadeau terug. Vandaar: laatste klik wint, ook over een
   * verversing heen. Ze leven alleen zolang de pagina leeft; een echte herlading
   * haalt de stand uit de wagen zelf. */
  const keuzeLokaal = new Map();
  const tredesOpen = new Set();

  function cadeauStandHerstellen() {
    keuzeLokaal.forEach((waarde, trede) => {
      const radios = [...document.querySelectorAll('input[type="radio"][data-cadeau]')].filter(
        (r) => r.dataset.cadeau === trede,
      );
      // ⚠ Alleen herstellen als de onthouden waarde nog bestáát. De waarde is
      // `titel (sku)` en de sku komt uit de eerst-leverbare variant; raakt die
      // smaak uitverkocht, dan drijft de waarde af en zette de oude versie élke
      // radio van de trede uit. Daarna vond `cadeauRegelsSyncen` niets in
      // `gewenst`, haalde het cadeau uit de wagen en schreef een leeg attribuut —
      // een verdiend cadeau dat stil verdween. Geen match = de serverstand
      // (`checked` uit Liquid) blijft staan.
      if (!radios.some((r) => r.value === waarde)) return;
      radios.forEach((r) => {
        r.checked = r.value === waarde;
      });
    });
    document.querySelectorAll('details.cd-cadeau-trede').forEach((d) => {
      const sleutel = d.querySelector('[data-cadeau]')?.dataset.cadeau;
      if (sleutel && tredesOpen.has(sleutel)) d.open = true;
    });
  }

  let regelsBezig = false;
  let regelsOpnieuw = false;
  /* De lópende ronde als belofte.
   *
   * ⚠ Zonder deze verwijzing kon een aanroeper níét echt wachten, en dat kostte
   * geld. `verversen()` roept `cadeausSchrijven()` aan en die roept
   * `cadeauRegelsSyncen()` aan; die zet `regelsBezig` al vóór zijn eerste
   * `await`. Een `await cadeauRegelsSyncen()` dáárna — precies wat
   * de haak `smWagenHersynchroniseren` deed voor de oude wagenpagina — viel dus door
   * de her-intreepoort en loste meteen op. Gevolg: wie van 18 naar 17 ging en
   * Afrekenen klikte, werd doorgestuurd terwijl de `/cart/change.js` die het
   * niet-verdiende cadeau weghaalt nog onderweg was — en het cadeau ging gratis
   * mee. Gevonden in de review van 25-08-2026.
   *
   * De belofte dekt óók de ingehaalde ronde: anders wacht de knop wel op de
   * eerste ronde maar niet op de correctie die daarna kwam. */
  let regelsLopend = null;

  function cadeauRegelsSyncen() {
    // Niet wéggooien maar onthouden: wie twee keer snel wisselt verwacht dat de
    // tweede klik telt, niet dat hij verdampt omdat de eerste nog liep.
    if (regelsBezig) {
      regelsOpnieuw = true;
      return regelsLopend || Promise.resolve();
    }
    regelsBezig = true;
    regelsLopend = (async () => {
      try {
        // Lus en geen recursie, om dezelfde reden als bij `cadeauVersturen`: een
        // staartaanroep zou de belofte met zichzelf kunnen oplossen. Een ronde die
        // tijdens deze ronde werd aangevraagd hoort bíj deze belofte — anders wacht
        // de afrekenknop wel op de eerste ronde maar niet op de correctie erna.
        // ⚠ Met een dak erop. Deze lus staat sinds de afrekenknop hem afwacht op
        // een blokkerend pad: de knop staat disabled tot hij klaar is. Convergeert
        // hij niet — Shopify's aantal-regels duwen de cadeauregel boven 1, of een
        // andere app zet hem terug na de change.js — dan draait hij eeuwig, gooit
        // niets (dus de catch daar vuurt niet) en is de knop permanent dood.
        // Drie rondes is ruim: ronde 1 zet de wagen goed, ronde 2 is de
        // her-intredende vraag van `verversen`, ronde 3 is marge.
        let ronden = 0;
        do {
          regelsOpnieuw = false;
          await regelsRonde();
          ronden += 1;
        } while (regelsOpnieuw && ronden < 3);
      } finally {
        regelsBezig = false;
        regelsOpnieuw = false;
      }
    })();
    return regelsLopend;
  }

  /* Een kortingscode op de verzending (FSJOEY) ziet Liquid niet: de server
   * rendert dan het tabeltarief, en de knop beloofde € 13,98 waar de checkout
   * € 4,03 zei. Gemeten 23-09-2026. `/cart.js` noemt de codes wél, alleen niet
   * wát ze doen. Een code die werkt maar nergens in de wagen een bedrag afhaalt,
   * werkt op de verzending — en hoeveel is pas in de checkout bekend. Dus geen
   * tarief gokken: de code tonen en de knop op het bedrag zonder verzending,
   * precies wat de checkout toont vóór het bezorgadres. Draait mee in elke
   * cadeauronde, en die volgt op elke verversing. */
  function verzendCodeTonen(cart) {
    const zichtbaar = new Set(
      (cart.cart_level_discount_applications || []).map((a) => String(a.title).toUpperCase()),
    );
    (cart.items || []).forEach((i) =>
      (i.line_level_discount_allocations || []).forEach((d) =>
        zichtbaar.add(String(d.discount_application?.title).toUpperCase()),
      ),
    );
    const code = (cart.discount_codes || []).find((c) => c.applicable && !zichtbaar.has(String(c.code).toUpperCase()));
    if (!code) return;
    const waarde = document.querySelector('[data-cart-inner] [data-verzend-waarde]');
    if (waarde) waarde.textContent = `${code.code} · ${window.smT('sm.js.sm_cart_drawer.at_checkout', 'bij afrekenen')}`;
    // Álle hints: de voet én het label van de bezorgmijlpaal ("Gratis vanaf
    // €150"). Wat de code met de verzending doet is pas in de checkout bekend.
    // De knop hoeft niet bij: die noemt sinds 03-10 altijd het bedrag zonder
    // verzending.
    document.querySelectorAll('[data-cart-inner] [data-verzend-hint]').forEach((h) => h.remove());
  }

  async function regelsRonde() {
    // Gewenste stand: per gehaalde trede één variant. Een trede die niet gehaald
    // wordt rendert een lege waarde en valt hier dus vanzelf af.
    const gewenst = new Map();
    document.querySelectorAll('[data-cadeau-variant]').forEach((v) => {
      if (v.type === 'radio' && !v.checked) return;
      if (!v.value || !v.dataset.cadeauVariant) return;
      gewenst.set(v.dataset.cadeau, v.dataset.cadeauVariant);
    });

    const cart = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
    // Fail-closed: zonder wagen weten we niet of er een onverdiend cadeau in ligt.
    if (!cart) throw new Error('cart.js niet gelezen');
    verzendCodeTonen(cart);

    // Opruimen vóór toevoegen, en niet andersom: wie van cadeau wisselt zou anders
    // even twee gratis regels in de wagen zien staan.
    const gezien = new Set();
    const weg = [];
    for (const item of cart.items) {
      if (!item.properties || item.properties._tiered_gift !== 'true') continue;
      const trede = item.properties._tiered_gift_trede || '';
      const klopt =
        !gezien.has(trede) &&
        item.quantity === 1 &&
        gewenst.get(trede) === String(item.variant_id);
      if (klopt) gezien.add(trede);
      else weg.push(item.key);
    }

    // ⚠ Een verwijdering die mislukt (429, netwerk) is géén stille no-op meer: dan
    // staat er een cadeau in de wagen dat niet verdiend is, en de afrekenknop
    // wacht op deze ronde. Eén herhaalpoging (aantal 0 is idempotent), daarna
    // faalt de ronde en houdt de knop de checkout tegen. Codex-review 11-10.
    let veranderd = false;
    let wegMislukt = false;
    for (const key of weg) {
      if (await wagenPost('cart/change.js', { id: key, quantity: 0 })) veranderd = true;
      else wegMislukt = true;
    }

    for (const [trede, variant] of gewenst) {
      if (gezien.has(trede)) continue;
      // Mislukt dit — uitverkocht, of een variant die niet meer bestaat — dan blijft
      // het cart attribute staan en ziet fulfilment de keuze alsnog. Liever een
      // cadeau dat met de hand meegaat dan een afrekening die klapt.
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(variant),
              quantity: 1,
              properties: { _tiered_gift: 'true', _tiered_gift_trede: trede },
            },
          ],
        }),
      }).catch(() => null);
      if (r && r.ok) veranderd = true;
    }

    if (!veranderd) {
      if (wegMislukt) throw new Error('cadeauregel niet verwijderd');
      return;
    }

    // Verversen zodat de gratis regel meteen in de wagen staat. `verversen` roept
    // `cadeausSchrijven` weer aan; `regelsBezig` staat nog aan, dus die vraag
    // wordt als `regelsOpnieuw` ingehaald ná deze ronde en wél afgewacht. Geen
    // lus: die tweede ronde vindt de wagen op orde, zet `veranderd` niet en
    // ververst dus niet opnieuw.
    const html = await fetch(`${window.location.pathname}?section_id=${SECTIE}`)
      .then((r) => (r.ok ? r.text() : null))
      .catch(() => null);
    if (html) verversen(html);
    if (wegMislukt) throw new Error('cadeauregel niet verwijderd');
  }

  function verversen(html) {
    if (!html) return false;
    // Wie midden in het intikken van een aantal staat, mag zijn veld niet kwijt
    // raken aan een verversing die door een ándere regel is uitgelokt.
    const actief = document.activeElement;
    const focusStepper = actief && actief.closest ? actief.closest('[data-stepper]') : null;
    const focusKey = focusStepper ? focusStepper.dataset.key : null;
    const focusRol =
      actief && actief.matches
        ? actief.matches('[data-step-value]')
          ? 'veld'
          : actief.matches('[data-step]')
            ? actief.dataset.step
            : null
        : null;
    const focusInDrawer = Boolean(actief && actief.closest && actief.closest('[data-cart-inner]'));
    const vers = new DOMParser().parseFromString(html, 'text/html');
    const huidig = document.querySelector('[data-cart-inner]');
    const nieuw = vers.querySelector('[data-cart-inner]');
    if (!nieuw || !huidig) return false;

    // ⚠ Leg de leespositie vast vóór de vervanging. `innerHTML` gooit de
    // scrollcontainer wég en bouwt hem opnieuw op, dus die begint op 0: wie
    // onderin de la een gerecht uit "vaak samen besteld" toevoegde, stond daarna
    // weer bovenaan bij de voortgangsbalk — en moest terugzoeken waar hij was.
    // Twee posities, want de la en de wagenpagina scrollen niet op dezelfde
    // plek: in de la is `.cd-scroll` de scroller, op /cart scrolt het document.
    const scrollerVoor = huidig.querySelector('.cd-scroll');
    const scrollTopVoor = scrollerVoor ? scrollerVoor.scrollTop : 0;
    const paginaYVoor = window.scrollY;
    // Dezelfde sprong, horizontaal: de bijbestel-rij en de cadeauslots zijn
    // eigen scrollers. Wie doorgeschoven was naar de vierde tegel en er één
    // toevoegde, kreeg de rij terug op tegel één. Op index bewaard en niet op een
    // sleutel: de verse sectie draagt dezelfde rijen in dezelfde volgorde, en een
    // stabiele sleutel bestaat hier niet.
    const ZIJSCROLLERS = '.cd-feed-lijst, .cd-cadeau-slots';
    const zijVoor = [...huidig.querySelectorAll(ZIJSCROLLERS)].map((el) => el.scrollLeft);
    // De categoriekeuze in de bijbestel-rij is een CSS-only radiogroep, dus de
    // verse sectie brengt de server-standaard mee: wie op "Snacks" stond keek
    // ineens weer naar 300g.
    const feedTabVoor = huidig.querySelector('[name="cd-feed-tab"]:checked')?.id;

    huidig.innerHTML = nieuw.innerHTML;
    // Meteen terug, vóór alles wat hierna focus verplaatst of hoogte verandert.
    const scrollerNa = huidig.querySelector('.cd-scroll');
    if (scrollerNa && scrollTopVoor) scrollerNa.scrollTop = scrollTopVoor;
    // ⚠ De tab vóór de scrollposities: een lijst die nog `display: none` is neemt
    // geen `scrollLeft` aan, dus omgekeerd landt het herstel in het niets.
    if (feedTabVoor) {
      const tab = huidig.querySelector('#' + (window.CSS?.escape ? CSS.escape(feedTabVoor) : feedTabVoor));
      if (tab) tab.checked = true;
    }
    huidig.querySelectorAll(ZIJSCROLLERS).forEach((el, i) => {
      if (zijVoor[i]) el.scrollLeft = zijVoor[i];
    });
    // Vóór `cadeausSchrijven`, want die leest de radio's om te bepalen wat er in
    // de wagen hoort. Leest hij de teruggesprongen serverstand, dan draait hij de
    // verse keuze van de klant terug.
    cadeauStandHerstellen();
    qtyHerstellen();
    // ⚠ De verse sectie brengt een afrekenknop mee die de sérverstand kent. Staat
    // er nog een aantal in de rust te wachten, dan toont het veld al het nieuwe
    // getal terwijl die knop van het oude uitgaat — en dan rekent iemand af met
    // een wagen die niet is wat hij ziet. Op slot tot de laatste schrijfronde
    // geland is. Gevonden in de tweede Codex-review van 25-08-2026.
    if (qtyLokaal.size > 0) {
      const knopNa = document.querySelector('[data-cart-inner] [name="checkout"]');
      if (knopNa) knopNa.disabled = true;
    }
    if (focusKey && focusRol) focusTerug(actief, focusInDrawer, focusKey, focusRol);
    // Alleen corrigeren als er écht iets verschoven is. Onvoorwaardelijk
    // terugzetten zou een bezoeker die tijdens de schrijfronde zelf scrolt
    // terugduwen — precies de sprong die deze regel moet wegnemen.
    if (window.scrollY !== paginaYVoor) window.scrollTo(0, paginaYVoor);
    cadeausSchrijven();

    const versRoot = vers.querySelector('[data-cart-root]');

    // ⚠ Het wagentotaal moet hier mee overgeschreven worden. `[data-cart-root]`
    // is de búitenste laag en die wordt niet vervangen — alleen zijn `innerHTML`
    // — dus elk attribuut dat híér staat blijft hangen op de waarde van de
    // laatste volledige paginalading. Zonder deze regel toont de toevoegmelding
    // na een toevoeging het oude bedrag naast het nieuwe aantal: op een pagina
    // die met een lege wagen laadde las dat "1 artikel · totaal €0,00".
    const versTotaal = versRoot?.dataset.cartTotaal;
    if (versTotaal !== undefined) root().dataset.cartTotaal = versTotaal;

    const aantal = versRoot?.dataset.cartCount;
    if (aantal !== undefined) {
      root().dataset.cartCount = aantal;
      document.querySelectorAll('[data-cart-count-badge]').forEach((badge) => {
        badge.textContent = aantal;
        badge.hidden = aantal === '0';
      });
      // De toegankelijke naam van de wagenknop hangt niet aan het telletje maar
      // aan het label van de link; zonder deze regel meldt een schermlezer nog
      // het aantal van de laatste volledige paginalading. Het label komt uit
      // Liquid, want daar staat het enkelvoud/meervoud al goed.
      const linklabel = versRoot?.dataset.cartLinklabel;
      if (linklabel) {
        document.querySelectorAll('[data-cart-link]').forEach((link) => {
          link.setAttribute('aria-label', linklabel);
        });
      }
    }
    campagneBalkBijwerken(vers);

    // Elke aanwezige melding krijgt dezelfde tekst. In de la zijn dat er twee —
    // één in het dialog, die werkt als hij open is, en één erbuiten, die werkt als
    // hij dicht is. Op de wagenpagina rendert de sectie de buitenste bewust niet,
    // want daar zou geen van beide uitgeschakeld zijn en hoorde je alles dubbel.
    const tekst = versRoot?.dataset.cartMeldingTekst;
    if (tekst) {
      document.querySelectorAll('[data-cart-melding]').forEach((el) => {
        el.textContent = tekst;
      });
    }
    return true;
  }

  // De actiebalk in de header draagt de wagenstand ("4 van 12 maaltijden · nog
  // 8 tot je gratis maaltijd") en een vullijn. Beide komen uit de verse sectie
  // (`sm-campagne`, variant 'voortgang'): de zin is daar in Liquid gemaakt, met
  // dezelfde telling en dezelfde tredes als de la zelf, dus hier staat geen
  // tweede rekenregel — alleen kopiëren. Lege zin = lege wagen: dan zet de
  // balk zijn belofte terug (`data-camp-belofte`) en de vullijn op nul.
  // Geen balk op de pagina (actiebalk uit, campagne uit) = niets te doen.
  function campagneBalkBijwerken(vers) {
    const bron = vers.querySelector('[data-camp-voortgang]');
    const balk = document.querySelector('[data-camp-bar]');
    if (!bron || !balk) return;
    // Campagne uit of afgelopen sinds deze pagina laadde (`campagne_einde`
    // passeerde, of de schakelaar ging om): dan geeft de la geen tredes meer
    // en hoort de balk niet meer te beloven. Weg ermee, mét de sticky-offset
    // op nul — anders plakt de sectiegroep 35px te hoog en snijdt hij de
    // blauwe balk af (zie `--ann-h` in sm-header). De aankondiging die de
    // header dan zou tonen komt bij de volgende paginalading; dat is genoeg.
    // Bewust `remove()` en niet `hidden`: `.ann--actie` heeft `display: block`
    // in de CSS en wint dan van het attribuut (check-hidden-override).
    if (bron.dataset.actief !== '1') {
      const ann = balk.closest('.ann');
      if (ann) {
        ann.remove();
        document.documentElement.style.setProperty('--ann-h', '0px');
      }
      return;
    }
    const zin = bron.textContent.trim();
    const kop = balk.querySelector('[data-camp-kop]');
    const belofte = kop?.dataset.campBelofte || '';
    const tekst = zin || belofte;
    if (kop) kop.textContent = tekst;
    const kort = balk.querySelector('[data-camp-kop-kort]');
    if (kort) kort.textContent = (zin && bron.dataset.kort) || belofte;
    const vh = balk.querySelector('[data-camp-kop-vh]');
    if (vh) vh.textContent = tekst;
    balk.classList.toggle('camp-bar--bezig', Boolean(zin));
    balk.style.setProperty('--vul', (zin ? bron.dataset.vul || 0 : 0) + '%');
  }

  // Kaart-ATC wisselt naar de stepper zodra het product in de wagen ligt, en
  // terug zodra het eruit is. Beide standen staan al in de HTML; hier wordt
  // alleen omgeschakeld, zodat er geen markup in JS zit.
  function kaartStand(wrap, regel) {
    const stepper = wrap.querySelector('[data-stepper]');
    if (!stepper) return;
    if (regel && regel.quantity > 0) {
      stepper.dataset.key = regel.key;
      const veldK = stepper.querySelector('[data-step-value]');
        if (veldK.tagName === 'INPUT') veldK.value = regel.quantity;
        else veldK.textContent = regel.quantity;
    }
    wrap.toggleAttribute('data-in-cart', Boolean(regel && regel.quantity > 0));
  }

  function kaartenSync(cart) {
    if (!cart || !cart.items) return;
    document.querySelectorAll('[data-card-atc]').forEach((wrap) => {
      // ⚠ Cadeauregels overslaan. Ze matchen op `variant_id` net zo goed als een
      // betaalde regel, dus zonder deze toets sloeg de kaart van een cadeaumaaltijd
      // om naar de stepper-stand en wees de min-knop naar de gratis regel — de klant
      // kon dat product dan niet meer gewoon kopen. Gevonden in de Codex-review van
      // 25-08-2026.
      const regel = cart.items.find(
        (i) => String(i.variant_id) === wrap.dataset.variant && !(i.properties && i.properties._tiered_gift === 'true'),
      );
      kaartStand(wrap, regel);
    });
    kaartenGewijzigd();
  }

  // Aankondiging, geen tweede schrijver. Wie meeluistert leest de stand uit de
  // kaarten die hierboven al bijgewerkt zijn — hij haalt de wagen niet zelf op
  // en post niets. Zonder dit bleef de rijteller in stap 4 van de pakket-PDP op
  // de serverstand staan: die sectie wordt bij een AJAX-mutatie niet ververst.
  const kaartenGewijzigd = () => document.dispatchEvent(new CustomEvent('sm:kaarten'));

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.action || !form.action.includes('/cart/add')) return;

    // Hier stonden twee poorten die een keuzepakket (`data-keuzepakket`, en als
    // vangnet elk formulier met `properties[...]`) langs de AJAX-route stuurden:
    // gewone submit, volledige paginalading, en de klant landde op /cart. Dat is
    // precies de sprong die deze la moest wegnemen, en op het duurste product in
    // de winkel — een try-out-pakket — kreeg juist niemand hem te zien.
    //
    // Weg kan het omdat de bescherming ergens anders vandaan komt dan gedacht:
    // de app-embed zet zeven `required` selects in het formulier, en de browser
    // draait zijn eigen validatie VÓÓR het `submit`-event. Vuurt dit event, dan
    // zijn de zeven keuzes ingevuld — of ze staan er niet, en dan hield ook de
    // oude native submit niets tegen. De ordervorm verandert evenmin:
    // `new FormData(form)` draagt dezelfde velden naar `/cart/add.js` als een
    // native post naar `/cart/add`, inclusief de hidden spiegel die de app naast
    // zijn selects bouwt.
    //
    // Wat er wél bij moet: een app die zijn eigen validatie draait en de
    // verzending afbreekt, moet dat kunnen blijven doen. `defaultPrevented` is
    // die stem — wij luisteren in de bubbelfase, dus een handler op het formulier
    // zelf is al geweest.
    if (event.defaultPrevented) return;

    // Altijd onderscheppen, ook als er al een verzoek loopt. Hier stond een
    // `if (bezig) return` vóór deze regel, met als afweging dat een volledige
    // paginalading beter is dan een klik die stil verdwijnt. Die afweging klopte,
    // maar de uitkomst niet: het formulier postte dan native naar /cart/add en de
    // klant belandde op de winkelwagenpagina. Wachten is de derde optie die er
    // niet was.
    event.preventDefault();

    // Dezelfde toevoeging staat al in de rij: niets doen. Zonder deze poort gaf
    // een dubbelklik tijdens een lopende wagenactie twee stuks (Codex 11-10).
    if (toevoegBezig.has(form)) return;

    // Upselltegel: alleen id + quantity. Op een keuzepakket-PDP hangt de SB-embed zijn
    // Meal-velden ook in dit formulier; uit het formulier zelf, zodat ook de native
    // terugval (`form.submit()`) schoon blijft.
    if (form.classList.contains('cd-tegel-atc')) {
      form.querySelectorAll('[name]').forEach((veld) => {
        if (veld.name !== 'id' && veld.name !== 'quantity' && veld.name !== 'form_type' && veld.name !== 'utf8') veld.remove();
      });
    }
    // De keuze van NU vastleggen, niet die van straks: de taak kan achter een
    // andere wagenactie wachten, en wie intussen een andere variant kiest mag
    // die eerdere klik niet laten veranderen. Knop meteen dicht.
    const knop = form.querySelector('[type="submit"]');
    const data = new FormData(form);
    data.append('sections', SECTIE);
    data.append('sections_url', window.location.pathname);
    toevoegBezig.add(form);
    if (knop) {
      knop.disabled = true;
      knop.setAttribute('data-cd-bezig', '');
    }
    inWachtrij(() => toevoegen(form, data, knop)).finally(() => {
      toevoegBezig.delete(form);
      if (knop && !navigeert) knop.removeAttribute('data-cd-bezig');
    });
  });
  const toevoegBezig = new WeakSet();

  // Eén toevoeging, uitgevoerd vanuit de rij. Zet `bezig` niet zelf: dat doet
  // `inWachtrij`, en die weet ook wanneer de laatste taak klaar is.
  async function toevoegen(form, data, knop) {

    // Vanaf het moment dat `fetch` oplost heeft de server de toevoeging gezien.
    // Alles daarná — ook het lezen van de body — mag dus nooit meer op
    // `form.submit()` uitkomen: een afgebroken body-lees op een haperende
    // verbinding zou van één klik twee stuks maken. Alleen een mislukte fetch,
    // waarbij het verzoek de server niet haalde, valt terug op de gewone route.
    let respons;
    try {
      respons = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
    } catch {
      // Een afgewezen `fetch` zegt níét of het verzoek Shopify gehaald heeft. Het
      // kan zijn dat er niets is toegevoegd, maar ook dat de toevoeging geslaagd
      // is en alleen het antwoord onderweg wegviel. Opnieuw versturen zou in dat
      // tweede geval van één klik twee stuks maken; doorsturen naar de wagen laat
      // de klant zien wat er werkelijk in zit, in beide gevallen.
      naarWagen();
      return;
    }

    // Een afgewezen toevoeging (uitverkocht, limiet) laat Shopify zelf
    // afhandelen op de gewone route — dan ziet de klant de echte melding.
    // /cart/add.js voegt bij een 422 niets toe, dus opnieuw versturen dubbelt niet.
    let gewisseld = false;
    if (!respons.ok) {
      const eerder = await kennEerderMelding(respons);
      if (eerder) {
        if (knop) knop.disabled = false;
        const vers = await verseWagen();
        if (vers) verversen(vers);
        meldZichtbaar(form, eerder.tekst, eerder.link);
        // Staat de Liquid-melding (ingelogd, pakket al in de wagen) er al, dan
        // geen tweede blok in de la; toast en live-gebied blijven.
        if (document.querySelector('[data-cart-inner] [data-kenn-eerder]')) {
          document.querySelector('[data-cart-inner] .cd-tryout-noot')?.remove();
        }
        return;
      }
      const keuze = await bundelKeuzeMelding(respons);
      if (keuze) {
        if (knop) knop.disabled = false;
        meldZichtbaar(form, keuze);
        return;
      }
      if (!(await isTryoutWeigering(respons))) {
        navigeert = true;
        form.submit();
        return;
      }
      respons = await tryoutWisselen(data, form);
      if (!respons) {
        // Oude try-out staat er weer; geen native submit, die toont alleen de
        // kale Shopify-foutpagina.
        if (knop) knop.disabled = false;
        // De la open: met la en toast dicht zag de klant anders niets (Codex 05-10).
        const vers = await verseWagen();
        if (vers) verversen(vers);
        meldZichtbaar(form, TRYOUT_CONTROLEER);
        return;
      }
      gewisseld = true;
    }

    let uitkomst;
    try {
      uitkomst = await respons.json();
    } catch {
      // De toevoeging is geslaagd, alleen het antwoord kwam niet aan. Doorsturen
      // naar de wagen laat de klant zien wat er werkelijk in zit.
      naarWagen();
      return;
    }

    if (knop) knop.disabled = false;

    // Try-out: één per bestelling — zie `tryoutEnkel()`.
    let html = uitkomst.sections && uitkomst.sections[SECTIE];
    let tryoutRegel = '';
    const nieuw = uitkomst.items ? uitkomst.items[0] : uitkomst;
    if (isTryout(nieuw)) {
      const enkel = await tryoutEnkel(nieuw.key);
      tryoutRegel = gewisseld && !enkel ? TRYOUT_VERVANGEN : tryoutTekst(enkel);
      // Is er iets aan de wagen gedaan, dan geldt alleen de HTML van ná die
      // poging — nooit de snapshot van /cart/add.js.
      if (enkel) html = enkel.html;
      // Bij een samengevoegde regel (aantal 2 → 1) zou de toast de dubbele
      // regelprijs tonen.
      nieuw.final_line_price = nieuw.final_price;
      if (!html) {
        // Geen verse wagen: la ongewijzigd, eerlijke melding, geen redirect.
        // De wagenstand in de toast zou oud zijn, dus die blijft leeg.
        toastTonen(nieuw);
        const stand = document.querySelector('[data-cart-toast-stand]');
        if (stand) stand.textContent = '';
        tryoutMelden(tryoutRegel);
        return;
      }
    }
    // Toevoegen opent de drawer niet meer. Er stond hier `openen()` vóór
    // `verversen()`, met als reden dat er twee `[data-cart-melding]`-regio's zijn
    // — één in het dialog, één erbuiten — en dat een wissel van inertheid ná het
    // schrijven een schermlezer beide kon laten horen. Die redenering vervalt met
    // de drawer dicht: het dialog blijft `display: none`, dus alleen de regio
    // erbuiten staat in de toegankelijkheidsboom en spreekt één keer.
    // Kwam de klant via "Wijzigen" op een pakket hier, dan gaat het oude pakket
    // nu weg; de HTML van ná die verwijdering is dan de juiste.
    const vervangen = await bundelVervangen(form);
    if (vervangen) html = vervangen.html;
    if (!verversen(html)) {
      naarWagen();
      return;
    }
    // Mislukt: beide pakketten staan erin. Melding waar de klant kijkt (la, of
    // onder de knop in wagenpagina-modus) en geen succesmelding erna.
    // Niet "probeer opnieuw": opnieuw toevoegen zou een derde pakket maken. De
    // klant haalt het oude met één tik weg in de la (Codex 11-10).
    if (vervangen?.mislukt) {
      const tekst =
        document.querySelector('[data-cart-inner] [data-cart-bundel-fout]')?.dataset.cartBundelFout ||
        'Je vorige pakket staat nog in je winkelwagen. Haal het daar weg als je het niet meer wilt.';
      meldZichtbaar(form, tekst, { href: (window.Shopify?.routes?.root || '/') + 'cart', label: window.smT('sm.js.sm_cart_drawer.to_cart', 'Naar je winkelwagen') });
      return;
    }
    const regel = uitkomst.items ? uitkomst.items[0] : uitkomst;
    // De melding hoort alleen te komen als de klant de wagen níét al ziet. Twee
    // gevallen waarin hij hem wél ziet: de la staat open (toevoegen kan ook vanuit
    // de bijbestel-rij erín), of we staan op de wagenpagina, waar de zojuist
    // ververste lijst de nieuwe regel al toont.
    //
    // ⚠ De toets is bewust niet "is er een dialog": in de stille vorm — de winkel
    // staat op wagenpagina en we zijn niet op /cart — is er géén dialog, en dan
    // is de melding juist het enige dat de klant vertelt dat er iets gebeurd is.
    const wagenInBeeld = Boolean(drawer()?.open) || Boolean(document.querySelector('.cd--pagina'));
    if (!wagenInBeeld) toastTonen(regel);
    tryoutMelden(tryoutRegel);
    // Niet alleen het formulier dat verstuurde: élke plek die deze variant toont.
    // Stap 4 van de pakket-PDP en de aanbevelingsrij in de la kunnen hetzelfde
    // gerecht tonen, en `sm-pakket` wordt na een AJAX-toevoeging niet opnieuw
    // gerenderd — alleen de drawer-sectie. Zonder deze regel bleef daar "Voeg
    // toe" staan terwijl het gerecht al in de wagen lag.
    document
      .querySelectorAll('[data-card-atc][data-variant="' + regel.variant_id + '"]')
      .forEach((wrap) => kaartStand(wrap, regel));
    kaartenGewijzigd();

    // Eén seam naar buiten, zodat een pagina die géén wagenicoon draagt zelf kan
    // bevestigen dat er iets is toegevoegd.
    //
    // Aanleiding: de segment-landingspagina's. `sm-lp-header` heeft geen
    // winkelwagen, dus `toast()` hierboven is daar `null` en `toastTonen` keert
    // stil terug. De la gaat sinds de wijziging hierboven ook niet meer open.
    // Samen betekent dat: op een LP klikt de klant "In de winkelwagen", de
    // toevoeging slaagt, en er gebeurt zichtbaar niets. Op de duurste klik van
    // de funnel.
    //
    // Bewust een event en geen `openen()` hier: op de winkelpagina's is de
    // toast-route een besluit dat blijft staan. `sm-lpseg.js` luistert en opent
    // de la alleen dáár waar er geen andere bevestiging is.
    document.dispatchEvent(new CustomEvent('sm:cart:toegevoegd', { detail: { regel } }));
  }

  /* Pakket wijzigen = vervangen. Alleen een toevoeging uit een formulier dat
   * de bundelvariant zelf draagt (het `id`-veld of een optie ervan — dus de
   * PDP van dát pakket, niet een upsell op dezelfde pagina), binnen 30
   * minuten, haalt het oude pakket weg. Geen netwerklookup: een haperende
   * lookup liet eerder twee pakketten stil staan (Codex 11-10). */
  const BUNDEL_VERVANG = 'sm-bundel-vervang';
  function bundelVervangLezen() {
    try {
      const v = JSON.parse(sessionStorage.getItem(BUNDEL_VERVANG) || 'null');
      if (!v || !Array.isArray(v.keys) || !v.variant || Date.now() > v.tot) {
        sessionStorage.removeItem(BUNDEL_VERVANG);
        return null;
      }
      return v;
    } catch {
      return null;
    }
  }
  // Het merkteken als dit formulier bij het te wijzigen pakket hoort; anders null.
  function bundelVervangVoor(form) {
    const v = bundelVervangLezen();
    if (!v || !form) return null;
    const doel = String(v.variant);
    const hoort = [...form.querySelectorAll('[name="id"]')].some(
      (el) => el.value === doel || [...(el.options || [])].some((o) => o.value === doel),
    );
    return hoort ? v : null;
  }
  // Na een geslaagde toevoeging: de oude regels weg in één update.js.
  // Geeft null (niets te doen) of { html, mislukt }; `html` kan null zijn —
  // dan is de eerdere snapshot hoe dan ook achterhaald (Codex 11-10).
  async function bundelVervangen(form) {
    const v = bundelVervangVoor(form);
    if (!v) return null;
    sessionStorage.removeItem(BUNDEL_VERVANG);
    const r = await wagenPost('cart/update.js', {
      updates: Object.fromEntries(v.keys.map((k) => [k, 0])),
      sections: SECTIE,
      sections_url: window.location.pathname,
    });
    if (r) {
      try {
        const html = (await r.json()).sections?.[SECTIE];
        if (html) return { html, mislukt: false };
      } catch {}
    }
    return { html: await verseWagen(), mislukt: !r };
  }

  const naarWagen = () => {
    navigeert = true;
    const wortel = window.Shopify?.routes?.root || '/';
    window.location.assign(wortel + 'cart');
  };

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-cart-open]');
    // Een modifier-klik hoort een nieuw tabblad te openen. De knop is met opzet
    // een échte link naar /cart gebleven; dat onderscheppen haalt precies de
    // enige reden weg waarom dat de moeite waard was.
    if (open && drawer() && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      openen();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      drawer()?.close();
      return;
    }

    const stap = event.target.closest('[data-step]');
    if (stap) {
      const stepper = stap.closest('[data-stepper]');
      const key = stepper.dataset.key;
      const nieuw = qtyHuidig(stepper) + Number(stap.dataset.step);
      if (nieuw < 0) return;
      qtyPlannen(key, nieuw);
      return;
    }

    // "Wijzigen" op een pakket: onthoud welke regels het oude pakket zijn. De
    // link gaat via /variants/<id> naar de PDP; wie daar opnieuw toevoegt,
    // vervangt het oude pakket in plaats van er een tweede naast te zetten
    // (Codex 11-10). Geen preventDefault: het blijft een gewone link.
    const wijzig = event.target.closest('[data-bundel-wijzig]');
    if (wijzig) {
      try {
        sessionStorage.setItem(BUNDEL_VERVANG, JSON.stringify({
          keys: wijzig.dataset.bundelWijzig.split(',').filter(Boolean),
          variant: Number(wijzig.dataset.bundelVariant),
          tot: Date.now() + 30 * 60 * 1000,
        }));
      } catch {}
      return;
    }

    // Een heel pakket in één keer weg: alle regels van de bundel in één
    // /cart/update.js, in plaats van 7–25 tikken op losse prullenbakken.
    const bundelWeg = event.target.closest('[data-bundel-weg]');
    if (bundelWeg) {
      const keys = bundelWeg.dataset.bundelWeg.split(',').filter(Boolean);
      if (keys.length === 0 || bundelWeg.disabled) return;
      bundelWeg.disabled = true;
      bundelWeg.closest('.cd-bundel')?.classList.add('cd-bundel--weg');
      keys.forEach((k) => {
        clearTimeout(qtyTimers.get(k));
        qtyTimers.delete(k);
        qtyLokaal.delete(k);
      });
      const afreken = document.querySelector('[data-cart-inner] [name="checkout"]');
      if (afreken) afreken.disabled = true;
      inWachtrij(async () => {
        try {
          const r = await wagenPost('cart/update.js', {
            updates: Object.fromEntries(keys.map((k) => [k, 0])),
            sections: SECTIE,
            sections_url: window.location.pathname,
          });
          if (!r) throw new Error('bundel niet verwijderd');
          const cart = await r.json();
          if (!verversen(cart.sections && cart.sections[SECTIE])) {
            naarWagen();
            return;
          }
          kaartenSync(cart);
        } catch {
          naarWagen();
        }
      });
      return;
    }

    const weg = event.target.closest('[data-regel-weg]');
    if (weg) {
      // Verwijderen wacht niet op de rustpauze: dit is een besluit, geen aanloop.
      qtyPlannen(weg.dataset.regelWeg, 0, true);
    }
  });

  /* ── Aantallen ─────────────────────────────────────────────────────────────
   * Lokaal en meteen; één schrijfronde per rustpauze.
   *
   * Tot 25-08-2026 deed élke klik een eigen `/cart/change.js` mét sectie-render en
   * zette hij intussen álle steppers op slot — plus `if (bezig) return`, dus een
   * klik tijdens dat wachten verdween gewoon. Wie 35 stuks wilde moest 34 keer
   * klikken én 34 keer wachten, en doortikken werkte actief tegen hem.
   *
   * Nu staat het getal meteen goed en gaat er na 450 ms rust één verzoek met het
   * eindaantal. De schrijfacties lopen nog steeds door `inWachtrij`, dus ze landen
   * op volgorde; wat eruit ging is de wachttijd vóór elke klik, niet de
   * serialisatie erachter.
   *
   * De afrekenknop blijft wél op slot zolang er een aantal openstaat. Dat is het
   * punt waar dit over geld gaat: staat de wagen op precies zeven maaltijden en
   * drukt iemand op min en meteen daarna op afrekenen, dan rekent hij anders af
   * met een aantal dat nog onderweg is.
   */
  const qtyLokaal = new Map();
  const qtyTimers = new Map();

  function qtyLees(el) {
    if (!el) return 0;
    const ruw = 'value' in el && el.tagName === 'INPUT' ? el.value : el.textContent;
    return Number(String(ruw).replace(/[^0-9]/g, '')) || 0;
  }
  function qtyHuidig(stepper) {
    const key = stepper.dataset.key;
    if (qtyLokaal.has(key)) return qtyLokaal.get(key);
    return qtyLees(stepper.querySelector('[data-step-value]'));
  }
  function qtyToon(key, aantal) {
    document.querySelectorAll(`[data-stepper][data-key="${key}"] [data-step-value]`).forEach((v) => {
      if (v.tagName === 'INPUT') v.value = aantal;
      else v.textContent = aantal;
    });
    // Ook het regelbedrag meteen (PostHog: rage clicks op "+" omdat er 1–2 s
    // niets leek te gebeuren). Stuksprijs × aantal is een voorlopige weergave;
    // de verse sectie zet het échte bedrag (met kortingen) terug.
    document.querySelectorAll(`[data-regel-prijs="${key}"]`).forEach((p) => {
      const stuk = Number(p.dataset.stukCent);
      if (!Number.isFinite(stuk)) return;
      p.textContent = '€' + ((stuk * aantal) / 100).toFixed(2).replace('.', /^en/i.test(document.documentElement.lang) ? '.' : ',');
    });
  }
  // Na een sectieverversing: dezelfde reden als bij de cadeaukeuze. De verse
  // sectie draagt de stand zoals de sérver hem kent, en die kent een aantal dat
  // nog in de rust wacht nog niet.
  function qtyHerstellen() {
    qtyLokaal.forEach((aantal, key) => qtyToon(key, aantal));
  }

  function qtyPlannen(key, aantal, direct) {
    qtyLokaal.set(key, aantal);
    qtyToon(key, aantal);
    const knop = document.querySelector('[data-cart-inner] [name="checkout"]');
    if (knop) knop.disabled = true;
    clearTimeout(qtyTimers.get(key));
    if (direct) {
      qtyTimers.delete(key);
      qtySchrijven(key);
    } else {
      qtyTimers.set(key, setTimeout(() => qtySchrijven(key), 450));
    }
  }

  function qtySchrijven(key) {
    qtyTimers.delete(key);
    inWachtrij(async () => {
      const aantal = qtyLokaal.get(key);
      if (aantal === undefined) return;
      try {
        const respons = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: aantal,
            sections: SECTIE,
            sections_url: window.location.pathname,
          }),
        });
        const cart = await respons.json();
        if (!respons.ok) {
          // Mislukt: de lokale stand is geen waarheid meer. Anders komt de klant
          // via de terugknop bij een la die nog op dit aantal wacht (Codex 11-10).
          qtyLokaal.clear();
          naarWagen();
          return;
        }
        // Alleen opruimen als er intussen niet alweer geklikt is: staat er een
        // nieuwer aantal, dan moet dát blijven staan tot zijn eigen ronde landt.
        if (qtyLokaal.get(key) === aantal) qtyLokaal.delete(key);
        if (!verversen(cart.sections && cart.sections[SECTIE])) {
          naarWagen();
          return;
        }
        kaartenSync(cart);
        // Staat de melding nog open, dan hoort hij de stand van ná deze klik te
        // tonen: + op een kaart is een toevoeging. Zonder dit bleef hij op
        // "2 artikelen · Nog 5 maaltijden" staan terwijl het icoon al 7 zei
        // (Joey 11-10). Ging de regel naar nul, dan blijft het getoonde gerecht
        // staan en volgen alleen stand en knoppen.
        const t = toast();
        if (t && !t.hidden) toastTonen(cart.items?.find((r) => r.key === key), true);
      } catch {
        // Zonder deze vangst zou een afgebroken verbinding een stille no-op zijn:
        // het aantal verandert niet en de klant hoort niet waarom.
        qtyLokaal.clear();
        naarWagen();
      }
    });
  }

  /* De wagenpagina heeft geen eigen cadeaulogica: de tredes staan in de la, en die
   * is op elke pagina aanwezig. Dit is de enige naar buiten toe zichtbare haak, en
   * hij bestaat voor één doel — de afrekenknop op `/cart` moet de cadeauregels
   * kunnen laten kloppen vóór hij doorstuurt. Eerst de sectie verversen (de la
   * toont daar de stand van vóór de wijziging), dan pas synchroniseren. */
  /* ⚠ De afrekenknop ín de la had dezelfde fout als die op /cart, en die is hier
   * pas de dérde deur naar dezelfde gratis maaltijd. `cd-form` is een gewoon
   * cart-formulier: hij post en navigeert zélf. Wie
   * een cadeau wisselt of onder een trede zakt en meteen afrekent, vertrekt dus
   * terwijl de `/cart/add.js` en `/cart/change.js` van `cadeauRegelsSyncen()` nog
   * onderweg zijn — met een cadeauregel die niet meer klopt.
   *
   * ⚠ En schrijf hier geen Liquid-tag uit, ook niet als voorbeeld: theme check
   * weigert elke Liquid-tag in een javascript-blok, óók in commentaar.
   *
   * Zelfde vorm als op de wagenpagina: onderscheppen, wachten tot beide
   * schrijfrondes landen, dan pas doorsturen. `cdAfrekenen` is de eenmaligheid —
   * zonder die vlag zou een tweede Enter tijdens het wachten een tweede ronde
   * starten. Gevonden in de derde Codex-review van 25-08-2026. */
  let cdAfrekenen = false;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form || form.id !== 'cd-form') return;
    // Eerst `preventDefault`, dán de eenmaligheid: andersom postte een tweede
    // submit tijdens de sync het formulier native (Codex 11-10).
    event.preventDefault();
    if (cdAfrekenen) return;
    cdAfrekenen = true;
    const knop = form.querySelector('[name="checkout"]');
    if (knop) knop.disabled = true;
    try {
      // Eerst alles wat nog in de rij staat (toevoegingen, aantallen): de
      // cadeaustand hangt van de wagen van ná die acties af.
      await alleTakenKlaar();
      // Aanhaken op een lopende ronde in plaats van er een af te dwingen: een
      // gewone `cadeauRegelsSyncen()` zou hier de her-intreepoort raken en dus
      // een extra /cart.js-ronde afdwingen op precies het pad waar de klant naar
      // een uitgeschakelde knop kijkt.
      await (regelsBezig ? regelsLopend : cadeauRegelsSyncen());
      // Mislukte eerdere attribuutronde (`cadeauStand` gewist): opnieuw plannen.
      if (cadeauStand === null) cadeauAttributenPlannen();
      await cadeauVersturen();
    } catch {
      // ⚠ Fail-closed, net als op /cart. Hier stond "doorsturen is beter dan
      // vastlopen"; op een pad dat een gratis product kan weggeven klopt dat niet.
      cdAfrekenen = false;
      syncMislukt();
      return;
    }
    // De rij kan de la ververst hebben: alleen doorsturen als de verse knop nog
    // open staat (onder de minimumafname is hij `aria-disabled` of weg).
    // Ook niet als er tijdens de sync een nieuwe wagenactie bijkwam (pakket
    // weg, aantal): dan is de cadeaustand al weer achterhaald (Codex 11-10).
    const vers = document.querySelector('#cd-form [name="checkout"]');
    if (!vers || vers.hasAttribute('aria-disabled') || qtyLokaal.size > 0 || openTaken > 0 || qtyTimers.size > 0) {
      cdAfrekenen = false;
      if (drawer()) openen();
      // Niet dicht laten hangen als die nieuwe taak zelf niets ververst
      // (bijv. een geweigerde toevoeging): na de rij de knop terug (Codex 11-10).
      alleTakenKlaar().then(() => {
        const k = document.querySelector('#cd-form [name="checkout"]');
        if (k && !k.hasAttribute('aria-disabled') && qtyLokaal.size === 0 && !cdAfrekenen) k.disabled = false;
      });
      return;
    }
    window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
  });

  /* ⚠ Terug uit de checkout kwam de afrekenknop dood terug. De browser zet de
   * pagina dan uit zijn back-forward-cache terug zoals hij hem verliet: de knop
   * nog `disabled` van de handler hierboven en `cdAfrekenen` nog aan, en niets
   * zette dat ooit terug. Wie een kortingscode ging proberen en terugkwam om iets
   * te wijzigen, keek naar een grijze knop die niets deed. Gemeten op live
   * 23-09-2026 (checkout → terug: `disabled`, beige, blijvend).
   *
   * De la wordt daarom opnieuw van de server gehaald: in de checkout kan er een
   * kortingscode bij gekomen zijn, en de bevroren la kent die niet — hij toonde
   * dan een bedrag dat de checkout net had tegengesproken. De verse sectie
   * brengt een knop mee die de server open of dicht zet (onder de minimumafname
   * blijft hij dicht), en `verversen` start de cadeauronde die de verzendcode
   * leest.
   *
   * ⚠ Lokale staat gaat eerst weg. Hier stond "staat er nog een aantal open
   * (`qtyLokaal`), dan niets" — maar na een mislukte wijziging (→ /cart → terug)
   * hield `qtyLokaal` die mislukte wijziging vast, keerde deze handler direct
   * terug en bleef de knop permanent grijs (Codex 11-10). Een pagina uit de
   * bfcache heeft geen lopende schrijfronde meer; de server is de waarheid. */
  window.addEventListener('pageshow', async (event) => {
    // Ook een "terug" zónder bfcache: dan komt de HTML uit de HTTP-cache en
    // toont de la de wagen van vóór de checkout (gemeten 11-10 op de preview:
    // la 8 artikelen, wagen 9).
    const terug = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (!event.persisted && !terug) return;
    cdAfrekenen = false;
    navigeert = false;
    qtyTimers.forEach((t) => clearTimeout(t));
    qtyTimers.clear();
    qtyLokaal.clear();
    document.querySelectorAll('[data-cd-bezig]').forEach((k) => {
      k.disabled = false;
      k.removeAttribute('data-cd-bezig');
    });
    const html = await fetch(`${window.location.pathname}?section_id=${SECTIE}`)
      .then((r) => (r.ok ? r.text() : null))
      .catch(() => null);
    // Kaarten op de pagina kunnen het mislukte aantal nog tonen.
    fetch(wagenUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => cart && kaartenSync(cart))
      .catch(() => {});
    if (html && verversen(html)) return;
    // Geen verse sectie: dan tenminste het eigen slot eraf, anders blijft de
    // knop dood — precies de storing waar deze handler voor bestaat.
    const knop = document.querySelector('#cd-form [name="checkout"]');
    if (knop && !knop.hasAttribute('aria-disabled')) knop.disabled = false;
  });


  // Zelf een aantal intikken. `change` en niet `input`: bij elke aanslag plannen
  // zou "35" onderweg als 3 wegschrijven. Enter bevestigt via blur.
  document.addEventListener('change', (event) => {
    const veld = event.target.closest('[data-step-value]');
    if (!veld || veld.tagName !== 'INPUT') return;
    const stepper = veld.closest('[data-stepper]');
    if (!stepper) return;
    const n = Math.max(0, Math.min(999, qtyLees(veld)));
    qtyPlannen(stepper.dataset.key, n);
  });
  document.addEventListener('keydown', (event) => {
    const veld = event.target.closest('[data-step-value]');
    if (!veld || veld.tagName !== 'INPUT' || event.key !== 'Enter') return;
    event.preventDefault();
    veld.blur();
  });

  // Een cadeaukeuze is een aanleiding om te schrijven, geen eigen schrijver. Zie de
  // waarschuwing bij `cadeausSchrijven`: hier stond een tweede `fetch` die alleen dít
  // ene attribuut postte, buiten `cadeauStand` om. Daarna wist de cache niet meer wat
  // de wagen wist, en de opruimronde sloeg over — cadeau op de order zonder drempel.
  //
  // De sectie wordt met opzet niet ververst: de radio staat al aan, en een
  // innerHTML-vervanging zou de focus weghalen bij iemand die net met de
  // pijltjestoetsen door de keuzes liep. `bezig` blijft er ook buiten — dit verzoek
  // raakt geen enkel aantal, en een cadeaukeuze mag een lopende stapklik niet
  // blokkeren.
  document.addEventListener('change', (event) => {
    const veld = event.target.closest('[data-cadeau]');
    if (!veld) return;
    if (veld.type === 'radio' && veld.checked) keuzeLokaal.set(veld.dataset.cadeau, veld.value);
    cadeausSchrijven();
  });

  // Open of dicht is een voorkeur van de klant, geen serverstand: een verversing
  // na een aantalswijziging mag een opengeklapte trede niet dichtslaan.
  document.addEventListener('toggle', (event) => {
    const d = event.target;
    if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('cd-cadeau-trede')) return;
    const sleutel = d.querySelector('[data-cadeau]')?.dataset.cadeau;
    if (!sleutel) return;
    if (d.open) tredesOpen.add(sleutel);
    else tredesOpen.delete(sleutel);
  }, true);

  // Klik op de backdrop sluit het paneel: buiten het dialog-vlak geklikt.
  document.addEventListener('click', (event) => {
    const d = drawer();
    if (d && d.open && event.target === d) d.close();
  });

  // Ook bij het laden: de drawer staat op elke pagina en kan al een gehaalde trede
  // met één cadeau tonen zonder dat er iets ververst is.
  cadeausSchrijven();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-collection-main"] && !Shopify.designMode) return;
  try {
    
  /* "Lees meer" op de lede (Joey 07-10). Eerst inkorten, dan meten: past de
     tekst in twee regels, dan gaat de inkorting er weer af en blijft de knop
     weg — een knop die niets openklapt is ruis. */
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-coll-lede]').forEach((lede) => {
        const knop = lede.parentElement.querySelector('[data-coll-lede-meer]');
        if (!knop || knop.dataset.klaar) return;
        knop.dataset.klaar = '1';
        lede.classList.add('coll-lede--kort');
        if (lede.scrollHeight <= lede.clientHeight + 2) {
          lede.classList.remove('coll-lede--kort');
          return;
        }
        const meer = knop.textContent;
        knop.hidden = false;
        knop.addEventListener('click', () => {
          const open = lede.classList.toggle('coll-lede--kort') === false;
          knop.setAttribute('aria-expanded', String(open));
          knop.textContent = open ? knop.dataset.labelMinder || meer : meer;
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  /* Meting collectiepagina (coll_bekeken · coll_klik), zelfde opzet als
     menu_open/menu_klik in sm-header: eigen events met sectie · item · positie,
     want autocapture hangt aan klassen. Beide varianten meten, anders is er
     geen vergelijking. `coll_wagen` (toegevoegd aan wagen) staat in sm-header,
     omdat die ook op de PDP moet vuren. Een meetfout breekt nooit de pagina. */
  (() => {
    // Deze bundel laadt op élke pagina (Shopify bundelt sectie-JS globaal). Zonder
    // deze grens vuurde coll_bekeken op de PDP als `huidig` en overschreef hij de
    // PostHog-variant van wie `nieuw` had (Codex 12-10).
    if (!document.querySelector('.coll-sectie')) return;
    const variant = document.documentElement.dataset.collVariant || 'huidig';
    const sectie = () => document.querySelector('.coll-sectie');
    const meet = (naam, props, beacon) => {
      try {
        if (typeof window.posthog?.capture !== 'function') return;
        window.posthog.capture(
          naam,
          { ...props, variant, collectie: location.pathname },
          beacon ? { transport: 'sendBeacon' } : undefined
        );
      } catch {}
    };

    // PostHog laadt via GTM pas na toestemming, vaak ná deze code. Even wachten,
    // en daarna stoppen: wie geen toestemming geeft, wordt niet gemeten.
    // Komt de toestemming later dan het wachten duurt, dan start Cookiebot's
    // accept-event het opnieuw; `gemeten` voorkomt een dubbele blootstelling
    // (Codex 12-10).
    let pogingen = 0;
    let gemeten = false;
    window.addEventListener('CookiebotOnAccept', () => {
      pogingen = 0;
      wacht();
    });
    function wacht() {
      if (gemeten) return;
      const ph = window.posthog;
      if (ph?.__loaded) {
        gemeten = true;
        try {
          ph.register({ coll_variant: variant });
        } catch {}
        const p = new URLSearchParams(location.search);
        meet('coll_bekeken', {
          gefilterd: [...p.keys()].some((k) => k.startsWith('filter.')),
          scherm: innerWidth < 700 ? 'mobiel' : 'desktop',
        });
        return;
      }
      if (++pogingen < 40) setTimeout(wacht, 500);
    }
    wacht();

    // Positie = plek binnen de eigen rij, 1-gebaseerd, zoals menu_klik.
    const pos = (el, groep) => (groep ? [...groep.querySelectorAll('a, button, summary')].indexOf(el) + 1 : 0);
    document.addEventListener('click', (e) => {
      const root = sectie();
      const el = e.target.closest('a[href], button, summary');
      if (!root || !el || !root.contains(el)) return;
      const cats = el.closest('[data-coll-sectie="categorie"]');
      const chips = el.closest('.fbar-chips');
      if (cats) meet('coll_klik', { sectie: 'categorie', item: el.dataset.collItem || '', positie: pos(el, cats) }, true);
      else if (chips) meet('coll_klik', { sectie: 'doel', item: el.dataset.goal || 'alle', positie: pos(el, chips) }, true);
      else if (el.matches('[data-fbar-open]')) meet('coll_klik', { sectie: 'filters', item: 'open', positie: 0 });
      else if (el.matches('.fbar-facet > summary')) meet('coll_klik', { sectie: 'facet', item: el.textContent.trim().split(/\s+/)[0], positie: 0 });
      else if (el.matches('.fbar-token, .fbar-clear, .fbar-pop-clear, [data-fbar-wis]')) meet('coll_klik', { sectie: 'wis', item: el.className, positie: 0 }, true);
    });
    // Een facetkeuze of sortering: in huidig verstuurt elke wijziging het
    // formulier, in nieuw de knop onderin de sheet. Beide komen als submit of
    // change langs; we tellen welke parameters er op dat moment aanstaan.
    const filterMeten = (form, via) => {
      try {
        const keys = [...new FormData(form)].filter(([k, v]) => v !== '' && k.startsWith('filter.')).map(([k]) => k.replace('filter.p.m.custom.', ''));
        meet('coll_klik', { sectie: 'filters', item: via, filters: [...new Set(keys)], positie: 0 }, true);
      } catch {}
    };
    document.addEventListener('change', (e) => {
      const form = e.target.closest('[data-fbar-form]');
      if (form && !form.closest('[data-fbar-sheet]') && sectie()?.contains(form)) filterMeten(form, e.target.name === 'sort_by' ? 'sorteren' : 'facet');
    });
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-fbar-form]');
      if (form?.closest('[data-fbar-sheet]')) filterMeten(form, 'toepassen');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-faq-gemak"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const zacht = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    const laad = (v) => { if (!v.src && v.dataset.src) v.src = v.dataset.src; };

    function initQuiz(root) {
      root.querySelectorAll('[data-gemak-quiz]').forEach((quiz) => {
        if (quiz.dataset.gemakKlaar) return;
        quiz.dataset.gemakKlaar = '1';
        const knoppen = [...quiz.querySelectorAll('[data-gemak-n]')];
        const lades = [...quiz.querySelectorAll('[data-gemak-lade]')];
        const kies = (n) => {
          knoppen.forEach((k) => k.setAttribute('aria-pressed', String(k.dataset.gemakN === n)));
          lades.forEach((lade) => {
            const aan = lade.dataset.gemakLade === n;
            lade.hidden = !aan;
            if (aan) lade.querySelector('[data-sm-vl]')?.classList.add('sm-vl--in');
          });
        };
        knoppen.forEach((k) => k.addEventListener('click', () => kies(k.dataset.gemakN)));
      });
    }

    function init(root) {
      initQuiz(root);
      root.querySelectorAll('[data-hhw-flow]').forEach((sectie) => {
        if (sectie.dataset.flowKlaar) return;
        sectie.dataset.flowKlaar = '1';
        const rail = sectie.querySelector('.hhw-flow-rail');
        if (!rail) return;
        const kaarten = [...rail.children];
        const tabs = [...sectie.querySelectorAll('[data-flow-naar]')];
        const max = () => rail.scrollWidth - rail.clientWidth;
        const naar = (kaart) => rail.scrollTo({
          left: (kaarten.indexOf(kaart) / Math.max(kaarten.length - 1, 1)) * max(),
          behavior: zacht ? 'smooth' : 'auto',
        });

        tabs.forEach((t) => t.addEventListener('click', () => {
          const k = kaarten.find((x) => x.dataset.flowHoofdstuk === t.dataset.flowNaar);
          if (k) naar(k);
        }));
        sectie.querySelectorAll('[data-flow-schuif]').forEach((knop) => knop.addEventListener('click', () => {
          const stap = kaarten[1] ? kaarten[1].offsetLeft - kaarten[0].offsetLeft : rail.clientWidth;
          rail.scrollBy({ left: stap * Number(knop.dataset.flowSchuif), behavior: zacht ? 'smooth' : 'auto' });
        }));

        const actief = () => {
          if (!tabs.length) return;
          const voortgang = max() > 0 ? rail.scrollLeft / max() : 0;
          const voor = kaarten[Math.round(voortgang * (kaarten.length - 1))];
          tabs.forEach((t) => {
            if (t.dataset.flowNaar === voor.dataset.flowHoofdstuk) t.setAttribute('aria-current', 'step');
            else t.removeAttribute('aria-current');
          });
        };
        let wacht = 0;
        rail.addEventListener('scroll', () => { cancelAnimationFrame(wacht); wacht = requestAnimationFrame(actief); }, { passive: true });

        const videos = [...sectie.querySelectorAll('.hhw-flow-video')];
        const knoppen = (v) => ({
          geluid: v.parentElement.querySelector('[data-flow-geluid]'),
          pauze: v.parentElement.querySelector('[data-flow-pauze]'),
        });
        const stil = (v) => { v.muted = true; v.loop = true; };
        const speel = (v) => { laad(v); v.play().catch(() => {}); };

        videos.forEach((v) => {
          const { geluid, pauze } = knoppen(v);
          const label = geluid.querySelector('span');
          v.addEventListener('volumechange', () => {
            geluid.setAttribute('aria-pressed', String(!v.muted));
            label.textContent = v.muted ? label.dataset.uit : label.dataset.aan;
          });
          const zetPauze = () => {
            pauze.setAttribute('aria-pressed', String(v.paused));
            pauze.setAttribute('aria-label', v.paused ? pauze.dataset.labelSpeel : pauze.dataset.labelPauze);
          };
          v.addEventListener('play', zetPauze);
          v.addEventListener('pause', zetPauze);
          zetPauze();

          pauze.addEventListener('click', () => {
            if (v.paused) { delete v.dataset.gestopt; speel(v); } else { v.dataset.gestopt = '1'; v.pause(); }
          });
          geluid.addEventListener('click', () => {
            if (v.muted) {
              videos.forEach((w) => { if (w !== v) { stil(w); if (!zacht) w.pause(); } });
              v.currentTime = 0;
              v.muted = false;
              v.loop = false;
              delete v.dataset.gestopt;
              speel(v);
            } else {
              stil(v);
              if (!zacht) v.pause();
            }
          });
          v.addEventListener('click', () => geluid.click());
          v.addEventListener('ended', () => { stil(v); if (zacht && !v.dataset.gestopt) speel(v); });
        });

        if (!('IntersectionObserver' in window)) return;
        const vio = new IntersectionObserver((items) => {
          for (const { target: v, intersectionRatio } of items) {
            if (intersectionRatio >= 0.5) {
              if (zacht && v.muted && !v.dataset.gestopt) speel(v);
            } else {
              if (!v.paused) v.pause();
              if (!v.muted) stil(v);
            }
          }
        }, { threshold: [0, 0.5] });
        videos.forEach((v) => vio.observe(v));
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-goals"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sm-reveal]').forEach((row) => {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    row.setAttribute('data-reveal-armed', '');
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        row.classList.add('inview');
        observer.disconnect();
      },
      { threshold: 0.25 }
    );
    observer.observe(row);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-header"]) return;
  try {
    
  // ── Menumeting, gedeeld door mobiel en desktop ─────────────────────────────
  // Eigen events in plaats van autocapture: die hangt aan CSS-klassen, en één
  // hernoeming laat de meting stil wegvallen. Alles in een try: een meetfout mag
  // het menu nooit breken. Zonder PostHog (geen consent) gaat er niets weg.
  // `variant: 'nieuw'` blijft vast in de events: bestaande PostHog-inzichten
  // filteren op die prop en zouden zonder stil op nul vallen.
  const menuMeet = (naam, props, beacon) => {
    try {
      if (typeof window.posthog?.capture !== 'function') return;
      // sendBeacon bij een klik: de pagina navigeert meteen weg en een gewone
      // request wordt dan afgebroken.
      window.posthog.capture(naam, { ...props, variant: 'nieuw' }, beacon ? { transport: 'sendBeacon' } : undefined);
    } catch {}
  };
  const menuData = document.querySelector('[data-sm-nav]')?.dataset || {};
  // Dezelfde vier props als het mobiele menu_open, zodat beide apparaten in één
  // query passen. Klantstatus komt uit Liquid: `$identify` vuurt op deze winkel niet.
  const menuOpenProps = () => ({
    pagina_type: menuData.menuPagina || '',
    wagen_aantal: Number(document.querySelector('[data-cart-count-badge]')?.textContent.trim() || 0),
    ingelogd: menuData.menuIngelogd === '1',
    aantal_orders: Number(menuData.menuOrders || 0),
  });
  // Positie binnen de eigen sectie, niet binnen een geneste: de balk (`balk`)
  // bevat de panelen, en die tellen hun keuzes zelf.
  const MENU_KEUZE = 'a[href], [data-keuzehulp-plek], form';
  const menuPositie = (el, sectie) =>
    sectie
      ? [...sectie.querySelectorAll(MENU_KEUZE)]
          .filter((k) => k.closest('[data-menu-sectie]') === sectie)
          .indexOf(el) + 1
      : 0;

  document.querySelectorAll('[data-sm-nav]').forEach((sheet) => {
    const root = sheet.closest('.sm-header-root');

    // ── Meting (menu_open · menu_klik · menu_dicht) — mobiel ─────────────────
    const d = sheet.dataset;
    // De menubeelden staan geparkeerd in data-nn-src/-srcset (zie de capture in
    // de markup); deze bundel draait na de paginalading, dus de LCP gaat voor.
    sheet.querySelectorAll('[data-nn-src]').forEach((img) => {
      if (img.dataset.nnSrcset) img.srcset = img.dataset.nnSrcset;
      img.src = img.dataset.nnSrc;
    });
    let geopend = 0;
    let via = '';
    let gescrold = 0;
    const gezien = new Set();
    // Alles in het menu dat een keuze is. De keuzehulp is een knop, geen link.
    const KEUZE = MENU_KEUZE;
    const meet = (naam, props, beacon) => menuMeet(naam, { ...props, apparaat: 'mobiel' }, beacon);
    const zicht =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (regels) => regels.forEach((r) => r.isIntersecting && gezien.add(r.target.dataset.menuSectie)),
            { root: sheet, threshold: 0.5 }
          )
        : null;
    sheet.querySelectorAll('[data-menu-sectie]').forEach((s) => zicht?.observe(s));
    sheet.addEventListener('scroll', () => (gescrold = Math.max(gescrold, Math.round(sheet.scrollTop))), {
      passive: true,
    });

    // Altijd sendBeacon: dicht valt vaak samen met een navigatie.
    const dicht = () => {
      if (!geopend) return;
      meet(
        'menu_dicht',
        {
          via: via || 'anders',
          ms_open: Math.round(performance.now() - geopend),
          gescrold_px: gescrold,
          zichtbare_secties: [...gezien],
        },
        true
      );
      geopend = 0;
    };
    const kies = (el, item, pad) => {
      const sectie = el.closest('[data-menu-sectie]');
      const keuzes = sectie ? [...sectie.querySelectorAll(KEUZE)] : [];
      meet(
        'menu_klik',
        {
          item,
          pad,
          sectie: sectie?.dataset.menuSectie || 'overig',
          positie: keuzes.indexOf(el) + 1,
          ms_sinds_open: Math.round(performance.now() - geopend),
        },
        true
      );
    };

    // De wagenbalk van variant nieuw. De wagenla ververst zijn eigen stand na
    // elke toevoeging (`[data-cart-root]` en `[data-cart-maaltijden]`); de balk
    // leest die bij het openen, zodat hij geen tweede telling bijhoudt.
    const wagen = sheet.querySelector('[data-nn-wagen]');
    const wagenBijwerken = () => {
      try {
        const la = document.querySelector('[data-cart-root]');
        if (!wagen || la?.dataset.cartCount === undefined) return;
        wagen.hidden = la.dataset.cartCount === '0';
        const n = Number(document.querySelector('[data-cart-maaltijden]')?.dataset.cartMaaltijden || 0);
        const w = wagen.dataset;
        wagen.querySelector('[data-nn-wagen-kop]').textContent =
          n === 1 ? w.nnEen : n > 1 ? w.nnMeer.replace('987654', n) : w.nnLeeg;
        if (la.dataset.cartTotaal) wagen.querySelector('[data-nn-wagen-totaal]').textContent = la.dataset.cartTotaal;
      } catch {}
    };

    const start = () => {
      geopend = performance.now();
      via = '';
      // Vanaf de echte stand: na een bfcache-herstel staat het paneel al gescrold,
      // en een observer die al "zichtbaar" zag meldt dat niet opnieuw.
      gescrold = Math.round(sheet.scrollTop);
      gezien.clear();
      zicht?.disconnect();
      sheet.querySelectorAll('[data-menu-sectie]').forEach((s) => zicht?.observe(s));
      wagenBijwerken();
      const badge = root?.querySelector('[data-cart-count-badge]');
      meet('menu_open', {
        pagina_type: d.menuPagina || '',
        wagen_aantal: Number(badge?.textContent.trim() || 0),
        ingelogd: d.menuIngelogd === '1',
        aantal_orders: Number(d.menuOrders || 0),
      });
    };
    root?.querySelector('[data-sm-nav-open]')?.addEventListener('click', () => {
      sheet.showModal();
      start();
    });
    // Terug via de back-forward-cache: het paneel staat nog open, maar `dicht()`
    // heeft de sessie bij het wegnavigeren al afgesloten. Opnieuw starten.
    addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      // Terug na een herbestelling: de knop staat nog op bezig.
      sheet.querySelectorAll('[data-nn-opnieuw]').forEach((knop) => knop.removeAttribute('aria-busy'));
      if (sheet.open && !geopend) start();
    });
    sheet.querySelectorAll('[data-sm-nav-close]').forEach((knop) => {
      knop.addEventListener('click', () => {
        via = 'kruis';
        sheet.close();
      });
    });
    // Klik op de backdrop sluit het paneel: buiten het dialog-vlak geklikt.
    sheet.addEventListener('click', (event) => {
      if (event.target === sheet) {
        via = 'backdrop';
        sheet.close();
        return;
      }
      const el = event.target.closest('a[href], [data-keuzehulp-plek]');
      if (!el) return;
      // Nieuw tabblad of venster: deze pagina en het menu blijven open, dus de
      // sessie loopt door.
      const elders = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || el.target === '_blank';
      // Bestel opnieuw los van de meetsessie: na de eerste tik staat `geopend`
      // op 0, en een tweede tik zou dan de permalink volgen en de wagen vervangen
      // terwijl add.js nog loopt.
      if (el.dataset.nnOpnieuw && !elders) {
        event.preventDefault();
        bestelOpnieuw(el);
      }
      if (!geopend) return;
      if (!el.href) {
        // De keuzehulp: een knop die de Aiden-zijbalk opent. Of het menu daarna
        // dichtgaat bepaalt Aiden; `close` of `pagehide` sluit de sessie af.
        kies(el, 'keuzehulp', '');
        via = 'klik';
        return;
      }
      const pad = new URL(el.href, location.href).pathname.replace(/\/$/, '');
      // `data-menu-item` waar het pad niets zegt (een cart-permalink, /search).
      kies(el, el.dataset.menuItem || pad.split('/').pop() || '/', pad);
      if (elders) return;
      via = 'klik';
      // Het vergrootglas in variant nieuw opent hetzelfde zoekpaneel als dat in
      // de header (met suggesties); de link naar /search is de terugval.
      const zoekOpen = el.hasAttribute('data-nn-zoek') && root?.querySelector('[data-sm-zoek-open]');
      if (zoekOpen) {
        event.preventDefault();
        sheet.close();
        zoekOpen.click();
        return;
      }
      dicht();
    });

    // Bestel opnieuw: de regels uit `sm-nav-opnieuw` bíj de wagen (een permalink
    // vervangt hem), dan naar /cart, waar de staffel meerekent.
    // shortcut: faalt add.js (bv. één regel net uitverkocht), dan valt hij terug
    // op de permalink, die wél een gevulde wagen vervangt; per regel toevoegen
    // als dat in de meting vaak blijkt te gebeuren.
    const bestelOpnieuw = (el) => {
      if (el.getAttribute('aria-busy') === 'true') return;
      el.setAttribute('aria-busy', 'true');
      const wortel = window.Shopify?.routes?.root || '/';
      try {
        fetch(wortel + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: JSON.parse(el.dataset.nnOpnieuw) }),
        })
          .then((r) => location.assign(r.ok ? wortel + 'cart' : el.href))
          .catch(() => location.assign(el.href));
      } catch {
        location.assign(el.href);
      }
    };
    // Zoeken en taalkeuze zijn formulieren, geen links.
    sheet.addEventListener('submit', (event) => {
      if (!geopend) return;
      const form = event.target;
      const zoek = form.getAttribute('role') === 'search';
      const pad = new URL(form.action || location.href, location.href).pathname;
      kies(form, zoek ? 'zoeken' : 'taal', pad);
      via = 'klik';
      dicht();
    });
    // Elke andere navigatie terwijl het menu open is (bv. de keuzehulp).
    addEventListener('pagehide', dicht);
    sheet.addEventListener('cancel', () => (via = 'escape'));
    // Elke sluiting loopt via `close`; sloot iets anders het paneel (bv. de
    // keuzehulp), dan blijft `via` leeg en telt hij als 'anders'.
    sheet.addEventListener('close', dicht);
  });

  document.querySelectorAll('[data-sm-zoek]').forEach((sheet) => {
    const root = sheet.closest('.sm-header-root');
    const veld = sheet.querySelector('input[name="q"]');
    const bak = sheet.querySelector('[data-sm-zoek-resultaat]');
    if (!veld || !bak) return;

    veld.setAttribute('role', 'combobox');
    veld.setAttribute('aria-expanded', 'false');
    veld.setAttribute('aria-autocomplete', 'list');

    // De zichtbare hoogte boven het iOS-toetsenbord; zie `--zoek-vh` in de CSS.
    const vv = window.visualViewport;
    const pasHoogte = () => {
      sheet.style.setProperty('--zoek-vh', `${vv.height}px`);
      sheet.style.setProperty('--zoek-top', `${vv.offsetTop}px`);
      const kop = sheet.querySelector('.zoek-vast')?.offsetHeight;
      if (kop) sheet.style.setProperty('--zoek-kop', `${kop}px`);
    };
    vv?.addEventListener('resize', pasHoogte);
    vv?.addEventListener('scroll', pasHoogte);

    root?.querySelector('[data-sm-zoek-open]')?.addEventListener('click', (event) => {
      event.preventDefault();
      sheet.showModal();
      veld.focus();
      if (vv) pasHoogte();
    });
    sheet.querySelector('[data-sm-zoek-close]')?.addEventListener('click', () => sheet.close());
    sheet.addEventListener('click', (event) => {
      if (event.target === sheet) sheet.close();
    });

    let actief = -1;
    const opties = () => [...bak.querySelectorAll('[role="option"]')];

    const markeer = (i) => {
      const lijst = opties();
      if (!lijst.length) return;
      // Rondlopen: vanaf de laatste omlaag komt de eerste, en andersom.
      actief = (i + lijst.length) % lijst.length;
      lijst.forEach((optie, n) => optie.setAttribute('aria-selected', n === actief ? 'true' : 'false'));
      const gekozen = lijst[actief];
      veld.setAttribute('aria-activedescendant', gekozen.id);
      gekozen.scrollIntoView({ block: 'nearest' });
    };

    const leeg = () => {
      bak.innerHTML = '';
      actief = -1;
      veld.setAttribute('aria-expanded', 'false');
      veld.removeAttribute('aria-activedescendant');
      veld.removeAttribute('aria-controls');
    };

    // Elke aanslag annuleert de vorige vlucht. Zonder dat kan een traag antwoord
    // op "ki" ná het snelle antwoord op "kip" binnenkomen en het overschrijven.
    let vlucht;
    let wachter;
    const zoek = async () => {
      const term = veld.value.trim();

      // Afbreken vóór de lengtecheck, niet erna. Wist iemand terug naar één teken
      // terwijl er nog een vlucht voor "kip" liep, dan maakte `leeg()` het paneel
      // leeg en vulde dat late antwoord het daarna alsnog — suggesties voor een
      // term die niet meer in het veld staat.
      vlucht?.abort();
      if (term.length < 2) return leeg();

      vlucht = new AbortController();
      const wortel = window.Shopify?.routes?.root || '/';
      const url = new URL(`${wortel}search/suggest`, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'sm-predictive-search');
      // Tags mee laten zoeken. Standaard kijkt search/suggest alleen naar titel,
      // producttype, varianttitel en leverancier; de zoekpagina indexeert tags
      // wel. Gemeten: "kip pakket" gaf 0 in het paneel tegen 56 op de pagina.
      // De vier standaardvelden staan er expliciet bij, want fields VERVANGT de
      // standaardlijst in plaats van hem aan te vullen.
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
      // Collecties erbij, en de andere drie expliciet erbij want `type` VERVANGT
      // de standaardlijst (net als `fields` hierboven) in plaats van hem aan te
      // vullen. Zonder deze regel komen er alleen producten terug — de reden dat
      // "pakket" tot 27-08 alleen losse bakjes gaf en nooit de pakkettencollectie.
      // Gemeten op de live winkel: `resources[type]=product,collection,page,article`
      // met dezelfde `fields` levert naast de producten óók Kip pakketten, Beef
      // pakketten, Halal pakketten en Vega-pakketten. `fields` breekt de
      // collectietak niet; dat is nagemeten, niet aangenomen.
      url.searchParams.set('resources[type]', 'product,collection,page,article');
      // Tot 10 per soort in plaats van 10 in totaal: anders verdringen categorieën
      // en artikelen de producten. `sm-predictive-search` kapt de rest weer af.
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[limit_scope]', 'each');
      try {
        const html = await fetch(url, { signal: vlucht.signal }).then((r) => (r.ok ? r.text() : ''));
        if (!html) return leeg();
        // De sectie-respons komt als volledige sectie-wrapper terug; alleen de
        // inhoud ervan hoort in het paneel.
        const gedeelte = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        bak.innerHTML = gedeelte ? gedeelte.innerHTML : html;
        // De sectie bouwt deze link uit `predictive_search.terms`, en die waarde
        // is al HTML-ontsnapt — `url_encode` codeert dan de entiteit in plaats van
        // het teken, dus "kip & beef" komt als "kip &amp; beef" op de zoekpagina
        // aan. Hier is de term nog onbewerkt, dus hier hoort de correctie.
        //
        // De verborgen velden gaan mee, en ze worden uit het formulier gelézen in
        // plaats van hier herhaald. `sm-zoekbalk` stuurt `options[prefix]=last` en
        // een `type`, en zonder die twee levert deze link een ándere uitkomst dan
        // op Enter drukken in hetzelfde veld: geen prefix-treffers op "kip", en
        // geen artikelen of pagina's. Overschrijven met een vaste lijst zou dat
        // vandaag oplossen en morgen opnieuw uiteenlopen zodra het snippet een
        // veld toevoegt — vandaar de kopie uit de DOM.
        const zoekform = veld.closest('form');
        const zoekpar = new URLSearchParams();
        zoekpar.set('q', term);
        zoekform?.querySelectorAll('input[type="hidden"][name]').forEach((h) => {
          if (h.name !== 'q' && h.value !== '') zoekpar.set(h.name, h.value);
        });
        bak.querySelector('.zoek-alles')?.setAttribute('href', `${wortel}search?${zoekpar}`);
        actief = -1;
        const lijst = bak.querySelector('[role="listbox"]');
        if (lijst) {
          lijst.id = lijst.id || 'sm-zoek-lijst';
          veld.setAttribute('aria-controls', lijst.id);
          veld.setAttribute('aria-expanded', 'true');
        } else {
          veld.setAttribute('aria-expanded', 'false');
        }
      } catch (error) {
        if (error.name !== 'AbortError') leeg();
      }
    };

    veld.addEventListener('input', () => {
      clearTimeout(wachter);
      wachter = setTimeout(zoek, 200);
    });

    veld.addEventListener('keydown', (event) => {
      const lijst = opties();
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        markeer(actief + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        markeer(actief - 1);
      } else if (event.key === 'Enter' && actief >= 0 && lijst[actief]) {
        // Alleen onderscheppen als er echt iets gemarkeerd staat; anders moet
        // het formulier gewoon naar /search kunnen posten.
        event.preventDefault();
        lijst[actief].querySelector('a')?.click();
      }
    });

    // Escape sluit het dialog zelf; leegmaken zodat een volgende opening niet
    // met de suggesties van de vorige zoekopdracht opent.
    sheet.addEventListener('close', leeg);
  });

  // ── Desktopmeting (beide varianten) ─────────────────────────────────────────
  // Eén open paneel tegelijk; `dmVia` is hoe het dichtging (escape · buiten ·
  // hover · klik · knop · focus · anders). menu_klik vuurt ook voor de balk
  // zelf (sectie `balk`: platte links en de try-outpil), met ms_sinds_open
  // alleen als er een paneel open stond.
  let dmGeopend = 0;
  let dmPaneel = '';
  let dmVia = '';
  const dmStart = (paneel) => {
    if (dmGeopend && dmPaneel === paneel) return;
    if (dmGeopend) dmDicht('wissel');
    dmGeopend = performance.now();
    dmPaneel = paneel;
    dmVia = '';
    menuMeet('menu_open', { ...menuOpenProps(), apparaat: 'desktop', paneel });
  };
  const dmDicht = (via) => {
    if (!dmGeopend) return;
    menuMeet(
      'menu_dicht',
      { apparaat: 'desktop', paneel: dmPaneel, via: via || dmVia || 'anders', ms_open: Math.round(performance.now() - dmGeopend) },
      true
    );
    dmGeopend = 0;
    dmVia = '';
  };
  addEventListener('pagehide', () => dmDicht());

  // <details> sluit zichzelf niet bij Escape of een klik ernaast.
  const closeMegas = (event) => {
    document.querySelectorAll('[data-sm-mega][open]').forEach((mega) => {
      if (event.type === 'keydown' || !mega.contains(event.target)) {
        // Esc vanuit het paneel: de focus terug naar de knop. Zonder dit belandt
        // hij op <body>, want de inhoud van een dichte <details> is weg.
        const terug = event.type === 'keydown' && mega.contains(document.activeElement);
        dmVia = event.type === 'keydown' ? 'escape' : 'buiten';
        mega.open = false;
        if (terug) mega.querySelector('summary')?.focus();
      }
    });
  };
  document.addEventListener('pointerdown', closeMegas);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMegas(event);
  });
  document.querySelectorAll('.hdr-nav [data-sm-mega]').forEach((mega) => {
    mega.addEventListener('toggle', () => {
      if (mega.open) dmStart(mega.dataset.menuPaneel || 'submenu');
      else if (dmPaneel === (mega.dataset.menuPaneel || 'submenu')) dmDicht(dmVia || 'klik');
    });
  });

  // Openen op hover (Joey, 27-08): wie het assortiment zoekt, moet niet eerst
  // hoeven klikken om te zien wat er is.
  //
  // Alleen achter `(hover: hover) and (pointer: fine)`. Op touch vuurt hover bij
  // een tap en blijft de stand daarna hangen — dan opent het paneel bij de tap
  // die het juist wilde sluiten. Onder 980px staat `.hdr-nav` sowieso op
  // `display: none`, maar de mediaquery is de poort, niet de breedte: een
  // hybride laptop met aanraakscherm is breed én grof.
  //
  // Twee vertragingen, en ze zijn niet hetzelfde getal:
  //
  // OPEN 90ms — een muis die op weg naar de winkelwagen langs "Maaltijden"
  // schiet, mag het paneel niet openen. De entree kost 238ms (7 rijen × 34ms
  // stagger) en die beweging bij elke passage is precies wat het comment bij
  // `sm-mega-rij` wilde vermijden toen openen nog een klik was. 90ms filtert de
  // passant zonder dat wie er bewust heen gaat het wachten voelt.
  //
  // DICHT 160ms — ruimer, want de muis moet van de summary naar het paneel
  // eronder kunnen zonder dat hij onderweg sluit. Het paneel plakt tegen de
  // summary aan (geen verticale gap in `.mega`), maar een diagonale beweging
  // naar de onderste rij verlaat het item kort aan de zijkant.
  const fijneMuis = matchMedia('(hover: hover) and (pointer: fine)');
  const nav = document.querySelector('.hdr-nav');
  if (nav) {
    let openKlok;
    let dichtKlok;
    const staak = () => {
      clearTimeout(openKlok);
      clearTimeout(dichtKlok);
    };

    nav.querySelectorAll('[data-sm-mega]').forEach((mega) => {
      mega.addEventListener('mouseenter', () => {
        if (!fijneMuis.matches) return;
        staak();
        openKlok = setTimeout(() => {
          // ⚠ Opnieuw toetsen of de muis er nog ís, en niet vertrouwen op het
          // annuleren bij vertrek. Die annulering dekte drie paden — naar een
          // ander mega-item, de nav in, de nav uit — en precies één niet: van
          // "Maaltijden" naar de platte link "Kennisbank" ernaast blijft binnen
          // `.hdr-nav`, dus `mouseleave` op de nav vuurt niet en geen enkel
          // ander mega-item krijgt een `mouseenter`. De klok liep gewoon door en
          // klapte het paneel open boven een link waar de klant al stond.
          //
          // `:hover` op het moment dat het telt dekt élk vertrekpad, ook de
          // paden die niemand heeft bedacht — een vierde `mouseleave`-listener
          // zou alleen het pad dekken dat deze review toevallig vond.
          // Gevonden in de tweede Codex-review van 27-08-2026.
          if (mega.matches(':hover')) mega.open = true;
        }, 90);
      });

      // De muisklik op de summary onderscheppen zolang hover het openen doet.
      // Zonder dit klapt een klik op het net geopende paneel hem weer dicht —
      // de muis staat er dan nog op, dus hover heropent hem niet, en de klant
      // zit met een menu dat knippert. Hover bestuurt het openen; de klik doet
      // niets. Op touch valt deze tak weg en blijft `<details>` zichzelf.
      //
      // ⚠ `event.detail > 0` is geen ruis-filter maar de hele voorwaarde.
      // Enter en spatie op een gefocuste `<summary>` sturen hetzelfde
      // click-event als de muis; zonder deze toets blokkeerde de regel dus óók
      // het toetsenbord, en kon wie "Maaltijden" met Enter had geopend hem niet
      // meer met Enter sluiten — alleen nog met Escape. Een echte muisklik telt
      // zijn kliks in `detail` (1, 2, …), een toetsenbord-activatie zet daar 0.
      // Gevonden in de Codex-review van 27-08-2026.
      mega.querySelector('summary')?.addEventListener('click', (event) => {
        if (fijneMuis.matches && mega.open && event.detail > 0) event.preventDefault();
      });
    });

    nav.addEventListener('mouseleave', () => {
      if (!fijneMuis.matches) return;
      staak();
      dichtKlok = setTimeout(() => {
        nav.querySelectorAll('[data-sm-mega][open]').forEach((mega) => {
          // Niet sluiten als het toetsenbord binnen het paneel staat: wie met
          // Tab in de lijst zit en per ongeluk de muis beweegt, verliest anders
          // zijn plek midden in de navigatie.
          if (!mega.contains(document.activeElement)) {
            dmVia = 'hover';
            mega.open = false;
          }
        });
      }, 160);
    });

    nav.addEventListener('mouseenter', staak);

    // menu_klik op de desktop: in de panelen én in de balk zelf.
    nav.addEventListener('click', (event) => {
      const el = event.target.closest('a[href], [data-keuzehulp-plek]');
      if (!el || !nav.contains(el)) return;
      const sectie = el.closest('[data-menu-sectie]');
      const pad = el.href ? new URL(el.href, location.href).pathname.replace(/\/$/, '') : '';
      const elders = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || el.target === '_blank';
      menuMeet(
        'menu_klik',
        {
          apparaat: 'desktop',
          paneel: sectie?.dataset.menuSectie === 'balk' ? '' : dmPaneel,
          item: el.href ? el.dataset.menuItem || pad.split('/').pop() || '/' : 'keuzehulp',
          pad,
          sectie: sectie?.dataset.menuSectie || 'overig',
          positie: menuPositie(el, sectie),
          ms_sinds_open: dmGeopend ? Math.round(performance.now() - dmGeopend) : null,
        },
        true
      );
      if (!elders && dmGeopend) dmVia = 'klik';
    });
  }

  // ── Winkelpaneel desktop (variant nieuw, `sm-nav-winkel`) ──────────────────
  // Openen op hover én op klik. Hover bleef (Joey 27-08: wie het assortiment
  // zoekt hoeft niet eerst te klikken; 18 % van de desktopsessies gebruikt het),
  // maar met ruimere klokken dan het smalle lijstje van huidig (90/160ms): dit
  // paneel is zo breed als de header, en een muis die op weg naar de wagen langs
  // "Maaltijden" schiet mag dat vlak niet laten opflitsen. 200ms filtert die
  // passant; 300ms dicht laat een schuine beweging naar de tegels toe. Een klik
  // opent meteen, voor wie niet wil wachten en voor het toetsenbord.
  document.querySelectorAll('[data-sm-dm]').forEach((dm) => {
    const knop = dm.querySelector('[data-sm-dm-knop]');
    const paneel = dm.querySelector('.dm');
    if (!knop || !paneel) return;
    let openVia = '';
    let openKlok;
    let dichtKlok;
    const staak = () => {
      clearTimeout(openKlok);
      clearTimeout(dichtKlok);
    };
    // Beelden staan geparkeerd in data-nn-src (zie sm-header); pas laden voor
    // wie dit paneel op de desktop kan zien.
    const laadBeelden = () =>
      paneel.querySelectorAll('[data-nn-src]').forEach((img) => {
        if (img.dataset.nnSrcset) img.srcset = img.dataset.nnSrcset;
        img.src = img.dataset.nnSrc;
        delete img.dataset.nnSrc;
      });
    const breed = matchMedia('(min-width: 981px)');
    if (breed.matches) laadBeelden();

    const open = (via) => {
      staak();
      if (dm.hasAttribute('data-open')) return;
      laadBeelden();
      openVia = via;
      dm.setAttribute('data-open', '');
      knop.setAttribute('aria-expanded', 'true');
      dmStart('winkel');
    };
    const dicht = (via, focusTerug) => {
      staak();
      if (!dm.hasAttribute('data-open')) return;
      dm.removeAttribute('data-open');
      knop.setAttribute('aria-expanded', 'false');
      if (focusTerug) knop.focus();
      dmDicht(via);
    };

    knop.addEventListener('click', (event) => {
      if (!dm.hasAttribute('data-open')) return open(event.detail > 0 ? 'klik' : 'toets');
      // Op hover geopend en dan geklikt: blijven staan. Anders klapt de klik het
      // paneel dicht onder een muis die er nog op staat. Het toetsenbord (detail
      // 0) sluit wél, zodat Enter het ook weer dicht krijgt.
      if (openVia === 'hover' && event.detail > 0) {
        openVia = 'klik';
        return;
      }
      dicht('knop');
    });

    dm.addEventListener('mouseenter', () => {
      if (!fijneMuis.matches) return;
      staak();
      openKlok = setTimeout(() => dm.matches(':hover') && open('hover'), 200);
    });
    dm.addEventListener('mouseleave', () => {
      if (!fijneMuis.matches) return;
      staak();
      // Wie met het toetsenbord in het paneel staat, verliest zijn plek niet
      // door een muisbeweging.
      dichtKlok = setTimeout(() => !dm.matches(':has(:focus-visible)') && dicht('hover'), 300);
    });

    document.addEventListener('pointerdown', (event) => {
      if (!dm.contains(event.target)) dicht('buiten');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && dm.hasAttribute('data-open')) dicht('escape', dm.contains(document.activeElement));
    });
    // Met Tab het paneel uit: dicht. `relatedTarget` leeg (klik op een kaal
    // stuk paneel) telt niet als weggaan.
    dm.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !dm.contains(event.relatedTarget)) dicht('focus');
    });
    // Een gekozen link of de keuzehulp: het paneel mag dicht. Een tik later, zodat
    // menu_klik (op de nav, verderop in de bubbel) nog binnen de open sessie valt.
    paneel.addEventListener('click', (event) => {
      const el = event.target.closest('a[href], [data-keuzehulp-plek]');
      if (!el || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      setTimeout(() => dicht('klik'));
    });
    // Terug via de back-forward-cache: het paneel stond nog open.
    addEventListener('pageshow', (event) => event.persisted && dicht('anders'));
  });

  // --ann-h houdt de sticky-offset van de sectiegroep gelijk aan de hoogte van
  // de aankondigingsbalk. Die hoogte hangt af van de vensterbreedte doordat de
  // tekst afbreekt, dus een vaste waarde loopt op een tussenformaat mis.
  (() => {
    let waarnemer = null;

    // De else-tak en de section-load-listener zijn niet optioneel. Zet de
    // merchant de aankondiging uit, dan rendert de sectie opnieuw zónder .ann
    // terwijl --ann-h op 40px blijft staan — de groep plakt dan op -40px en
    // snijdt de bovenste 40px van de blauwe balk af, de hele editor-sessie lang.
    // Andersom net zo: aankondiging aanzetten op een pagina die zonder laadde.
    const meet = () => {
      if (waarnemer) { waarnemer.disconnect(); waarnemer = null; }
      const ann = document.querySelector('.ann');
      if (!ann) {
        document.documentElement.style.setProperty('--ann-h', '0px');
        return;
      }
      const zet = () => document.documentElement.style.setProperty('--ann-h', ann.offsetHeight + 'px');
      zet();
      waarnemer = new ResizeObserver(zet);
      waarnemer.observe(ann);
    };

    meet();
    document.addEventListener('shopify:section:load', meet);
  })();

  // De countdown in de actiebalk staat in dagen en komt van de server. Alleen
  // op de laatste dag is dat te grof: dan tellen de uren. `data-camp-einde` is
  // het einde in epoch-seconden, in de winkeltijdzone uitgerekend door Liquid,
  // dus de klok van de bezoeker doet er niet toe. Elke andere dag doet dit
  // script niets — de servertekst blijft staan.
  (() => {
    const tijd = document.querySelector('[data-camp-tijd]');
    if (!tijd) return;
    const einde = Number(tijd.dataset.campEinde) * 1000;
    if (!einde) return;
    const rest = einde - Date.now();
    if (rest <= 0 || rest > 864e5) return;
    const uur = Math.max(1, Math.ceil(rest / 36e5));
    tijd.textContent = window.smT('sm.js.sm_header.uren_over', 'nog {uur} uur').replace('{uur}', uur);
  })();

  // Collectie-A/B (12-10-2026): "toegevoegd aan wagen" per variant. Hier en niet
  // in sm-collection-main, want de meeste toevoegingen gebeuren op de PDP ná de
  // collectie. Wie nooit een collectie zag heeft geen cookie en telt niet mee.
  // `sm:cart:toegevoegd` komt uit sm-cart-drawer na elke geslaagde toevoeging.
  // Het wagenattribuut gaat ook zonder PostHog-toestemming mee, zodat Shopify de
  // orders per variant kan tellen.
  (() => {
    let inWagen = '';
    // Terug uit de bfcache na een checkout: dan is er een nieuwe wagen zonder
    // attribuut, en de cache zou de schrijf overslaan (Codex 12-10).
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) inWagen = '';
    });
    document.addEventListener('sm:cart:toegevoegd', () => {
      try {
        const variant = document.cookie.match(/(?:^|; )sm_coll_variant=(huidig|nieuw)(?:;|$)/)?.[1];
        if (!variant) return;
        window.posthog?.capture?.('coll_wagen', {
          variant,
          pagina_type: location.pathname.split('/')[1] || 'home',
        });
        if (inWagen === variant) return;
        fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _coll_variant: variant } }),
          keepalive: true,
        })
          .then((r) => r.ok && (inWagen = variant))
          .catch(() => {});
      } catch {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-hhw-flow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const zacht = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    const laad = (v) => { if (!v.src && v.dataset.src) v.src = v.dataset.src; };

    function init(root) {
      root.querySelectorAll('[data-hhw-flow]').forEach((sectie) => {
        if (sectie.dataset.flowKlaar) return;
        sectie.dataset.flowKlaar = '1';
        const rail = sectie.querySelector('.hhw-flow-rail');
        const kaarten = [...rail.children];
        const tabs = [...sectie.querySelectorAll('[data-flow-naar]')];
        // Tabs en scrollpositie spiegelen elkaar: kaart i hoort bij i/(n−1) van de
        // scrollbare breedte. Een "vooraan staande kaart" werkt niet op desktop: daar
        // kan de rij maar een paar honderd pixels scrollen en komt de middelste groep
        // nooit vooraan (preview 06-10: "Bewaren" bleef onbereikbaar).
        const max = () => rail.scrollWidth - rail.clientWidth;
        const naar = (kaart) => rail.scrollTo({
          left: (kaarten.indexOf(kaart) / Math.max(kaarten.length - 1, 1)) * max(),
          behavior: zacht ? 'smooth' : 'auto',
        });

        tabs.forEach((t) => t.addEventListener('click', () => {
          const k = kaarten.find((x) => x.dataset.flowHoofdstuk === t.dataset.flowNaar);
          if (k) naar(k);
        }));
        sectie.querySelectorAll('[data-flow-schuif]').forEach((knop) => knop.addEventListener('click', () => {
          const stap = kaarten[1] ? kaarten[1].offsetLeft - kaarten[0].offsetLeft : rail.clientWidth;
          rail.scrollBy({ left: stap * Number(knop.dataset.flowSchuif), behavior: zacht ? 'smooth' : 'auto' });
        }));

        const actief = () => {
          const voortgang = max() > 0 ? rail.scrollLeft / max() : 0;
          const voor = kaarten[Math.round(voortgang * (kaarten.length - 1))];
          tabs.forEach((t) => {
            if (t.dataset.flowNaar === voor.dataset.flowHoofdstuk) t.setAttribute('aria-current', 'step');
            else t.removeAttribute('aria-current');
          });
        };
        let wacht = 0;
        rail.addEventListener('scroll', () => { cancelAnimationFrame(wacht); wacht = requestAnimationFrame(actief); }, { passive: true });

        // Video: pas laden als hij in beeld komt, pauzeren erbuiten (16,9 MB-les van de sporterrij).
        // De knoppen lezen hun stand uit de video zelf (play/pause/volumechange), zodat ze
        // nooit iets anders tonen dan wat er gebeurt. `gestopt` = de bezoeker pauzeerde zelf:
        // dan speelt hij ook in beeld niet meer vanzelf (WCAG 2.2.2, Codex-review 06-10).
        const videos = [...sectie.querySelectorAll('.hhw-flow-video')];
        const knoppen = (v) => ({
          geluid: v.parentElement.querySelector('[data-flow-geluid]'),
          pauze: v.parentElement.querySelector('[data-flow-pauze]'),
        });
        const stil = (v) => { v.muted = true; v.loop = true; };
        const speel = (v) => { laad(v); v.play().catch(() => {}); };

        videos.forEach((v) => {
          const { geluid, pauze } = knoppen(v);
          const label = geluid.querySelector('span');
          v.addEventListener('volumechange', () => {
            geluid.setAttribute('aria-pressed', String(!v.muted));
            label.textContent = v.muted ? label.dataset.uit : label.dataset.aan;
          });
          const zetPauze = () => {
            pauze.setAttribute('aria-pressed', String(v.paused));
            pauze.setAttribute('aria-label', v.paused ? pauze.dataset.labelSpeel : pauze.dataset.labelPauze);
          };
          v.addEventListener('play', zetPauze);
          v.addEventListener('pause', zetPauze);
          zetPauze();

          pauze.addEventListener('click', () => {
            if (v.paused) { delete v.dataset.gestopt; speel(v); } else { v.dataset.gestopt = '1'; v.pause(); }
          });
          geluid.addEventListener('click', () => {
            if (v.muted) {
              // Eén video met geluid tegelijk; de rest gaat terug naar stil.
              videos.forEach((w) => { if (w !== v) { stil(w); if (!zacht) w.pause(); } });
              v.currentTime = 0;
              v.muted = false;
              v.loop = false;
              delete v.dataset.gestopt;
              speel(v);
            } else {
              stil(v);
              if (!zacht) v.pause();
            }
          });
          // Tik op het beeld = de geluidsknop (live gemeten 06-10): wie op een stille
          // video tikt, wil horen wat Joey zegt — het beeld zelf deed niets.
          v.addEventListener('click', () => geluid.click());
          // Na afloop met geluid: terug naar stil in een lus.
          v.addEventListener('ended', () => { stil(v); if (zacht && !v.dataset.gestopt) speel(v); });
        });

        const vio = new IntersectionObserver((items) => {
          for (const { target: v, intersectionRatio } of items) {
            if (intersectionRatio >= 0.5) {
              if (zacht && v.muted && !v.dataset.gestopt) speel(v);
            } else {
              // Buiten beeld: pauzeren én het geluid terugzetten, anders toont de knop
              // bij terugkomst "Geluid uit" op een stilstaande video.
              if (!v.paused) v.pause();
              if (!v.muted) stil(v);
            }
          }
        }, { threshold: [0, 0.5] });
        videos.forEach((v) => vio.observe(v));
      });
    }
    if (!('IntersectionObserver' in window)) return;
    init(document);
    // De theme-editor vervangt de sectie zonder dit script opnieuw te draaien.
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-journey"] && !Shopify.designMode) return;
  try {
    
  /* Eén init per sectie-element. De theme editor rendert een sectie opnieuw en
     vuurt dan `shopify:section:load`; de vlag voorkomt dubbele klik-handlers, en
     de resize-listener is er maar één voor alle rails samen (geen stapel per
     her-render). Losgekoppelde rails vallen bij de eerstvolgende resize af. */
  const reisRails = new Map();
  window.addEventListener(
    'resize',
    () => {
      reisRails.forEach((plan, blok) => {
        if (blok.isConnected) plan();
        else reisRails.delete(blok);
      });
    },
    { passive: true },
  );

  function initReis(blok) {
    if (blok.dataset.reisKlaar) return;
    const rail = blok.querySelector('.reis-rail');
    if (!rail) return;
    blok.dataset.reisKlaar = '1';

    blok.querySelectorAll('[data-reis-schuif]').forEach((knop) => {
      knop.addEventListener('click', () => {
        // Kaartbreedte uit de eerste kaart, zodat de sprong meebeweegt met het
        // breakpoint in plaats van een vast getal te zijn.
        const kaart = rail.querySelector('.reis-kaart');
        const stap = kaart ? kaart.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
        const zacht = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        rail.scrollBy({ left: Number(knop.dataset.reisSchuif) * stap, behavior: zacht });
      });
    });

    if (blok.hasAttribute('data-reis-groot')) reisGroot(blok, rail);
  }

  document.querySelectorAll('.unbox--rail').forEach(initReis);
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.unbox--rail').forEach(initReis);
  });

  /* Vorm "groot": voortgangslijn en de knoppen aan/uit op de scrollstand. Eén
     scroll-listener per rail, door rAF gedrosseld. Geen inkom en geen actieve
     kaart meer (review 06-10: geen animatie). */
  function reisGroot(blok, rail) {
    const stippen = [...blok.querySelectorAll('.reis-voortgang__stip')];
    const vorige = blok.querySelector('[data-reis-schuif="-1"]');
    const volgende = blok.querySelector('[data-reis-schuif="1"]');
    let gepland = false;

    const meet = () => {
      gepland = false;
      const max = rail.scrollWidth - rail.clientWidth;
      if (max <= 1) {
        blok.setAttribute('data-alles', '');
        if (vorige) vorige.disabled = true;
        if (volgende) volgende.disabled = true;
        return;
      }
      blok.removeAttribute('data-alles');
      const x = Math.min(Math.max(rail.scrollLeft, 0), max);
      const p = x / max;
      const bereikt = Math.round(p * (stippen.length - 1));
      blok.style.setProperty('--reis-p', p.toFixed(4));
      stippen.forEach((s, i) => s.classList.toggle('is-bereikt', i <= bereikt));
      if (vorige) vorige.disabled = x <= 2;
      if (volgende) volgende.disabled = x >= max - 2;
    };
    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(meet);
    };
    rail.addEventListener('scroll', plan, { passive: true });
    reisRails.set(blok, plan);
    meet();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-lpseg-kladblok"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    function tagline(tl) {
      if (tl.dataset.lpsegKlaar) return;
      tl.dataset.lpsegKlaar = '1';
      var words = tl.textContent.trim().split(/\s+/);
      tl.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'w';
        s.textContent = w;
        tl.appendChild(s);
        if (i < words.length - 1) tl.appendChild(document.createTextNode(' '));
      });
      var ws = tl.querySelectorAll('.w');
      if (reduce || !hasIO) {
        ws.forEach(function (s) { s.classList.add('on'); });
        return;
      }
      var wio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(ws, e.target);
          e.target.style.transitionDelay = (idx * 45) + 'ms';
          e.target.classList.add('on');
          wio.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -30% 0px', threshold: 0.5 });
      ws.forEach(function (s) { wio.observe(s); });
    }

    function kladblok(pad) {
      if (pad.dataset.lpsegKlaar) return;
      pad.dataset.lpsegKlaar = '1';
      pad.classList.add('is-js');
      var kruis = pad.querySelector('.kruis');
      var agenda = pad.querySelector('.agenda');
      var rooster = pad.classList.contains('pad--rooster');
      var deels = pad.classList.contains('pad--deels');
      var weg = pad.querySelectorAll('.notepad li.weg');
      var np = agenda || pad.querySelector('.notepad');
      // Tijden gelijk aan de CSS: [kruis haal 1, kruis haal 2, einde potlood].
      // Weekplanner: t0 = --klad-kruis-t (680 + i·520 ms, i = laatste doorgestreepte regel).
      var t0 = deels ? parseFloat(getComputedStyle(pad).getPropertyValue('--klad-kruis-t')) : 0;
      var T = agenda ? [1720, 2270, 3020] : rooster ? [1800, 2350, 3100] : deels ? [t0, t0 + 550, t0 + 1300] : [3800, 4350, 5100];
      var tekenKruis = function () {
        if (agenda) {
          // Het kruis dekt precies de afspraken (de ul), niet het lege avondslot eronder.
          var ul = agenda.querySelector('ul');
          kruis.style.top = ul.offsetTop + 'px';
          kruis.style.height = ul.offsetHeight + 'px';
        } else if (rooster) {
          var lijst = pad.querySelector('.lijst');
          kruis.style.top = (lijst.offsetTop - 8) + 'px';
          kruis.style.height = (lijst.offsetHeight + 16) + 'px';
        } else if (deels && weg.length) {
          var a = weg[0], z = weg[weg.length - 1];
          kruis.style.top = (a.offsetTop - 6) + 'px';
          kruis.style.height = (z.offsetTop + z.offsetHeight - a.offsetTop + 12) + 'px';
        }
        var w = kruis.clientWidth, h = kruis.clientHeight;
        var p = kruis.querySelectorAll('path');
        kruis.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        p[0].setAttribute('d', 'M' + w * .04 + ' ' + h * .05 + ' Q' + w * .42 + ' ' + h * .56 + ' ' + w * .96 + ' ' + h * .94);
        p[1].setAttribute('d', 'M' + w * .95 + ' ' + h * .06 + ' Q' + w * .52 + ' ' + h * .40 + ' ' + w * .05 + ' ' + h * .95);
        return [[w * .04, h * .05], [w * .96, h * .94], [w * .95, h * .06], [w * .05, h * .95]];
      };
      var schrijf = function (hoeken) {
        var pen = pad.querySelector('.pen');
        // SVG kent geen offsetLeft/offsetTop (undefined → NaN): lees de positie uit de stijl.
        var ks = getComputedStyle(kruis);
        var kx = parseFloat(ks.left), ky = parseFloat(ks.top);
        var pt = [];
        // Weekplanner: alleen de doorgestreepte regels; de tijd per regel volgt --i (zoals de CSS).
        var txts = deels ? Array.prototype.map.call(weg, function (li) { return li.querySelector('.txt'); }) : pad.querySelectorAll('.txt');
        txts.forEach(function (t) {
          var i = parseInt(t.closest('li').style.getPropertyValue('--i'), 10);
          var x = t.offsetLeft, y = t.offsetTop, el = t.offsetParent;
          while (el && el !== np) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
          y += t.offsetHeight * 0.55;
          pt.push([200 + i * 520, x - 2, y, 1], [620 + i * 520, x + t.offsetWidth + 2, y, 1]);
        });
        if (!pt.length) return;
        if (deels) pt.unshift([0, pt[0][1], pt[0][2], 0], [pt[0][0] - 120, pt[0][1], pt[0][2], 0], [pt[0][0] - 20, pt[0][1], pt[0][2], 1]);
        else pt.unshift([80, pt[0][1], pt[0][2], 0], [180, pt[0][1], pt[0][2], 1]);
        if (agenda) {
          // Het potlood volgt de gebogen streep zelf (8 punten per haal), niet de rechte
          // lijn tussen begin en eind; die boog wijkt in een hoge agenda ~15 px af.
          kruis.querySelectorAll('path').forEach(function (p, i) {
            var L = p.getTotalLength();
            for (var k = 0; k <= 8; k++) { var q = p.getPointAtLength(L * k / 8); pt.push([T[i] + 450 * k / 8, kx + q.x, ky + q.y, 1]); }
          });
        } else {
          hoeken.forEach(function (h, i) { pt.push([[T[0], T[0] + 450, T[1], T[1] + 450][i], kx + h[0], ky + h[1], 1]); });
        }
        var eind = pt[pt.length - 1];
        pt.push([T[2], eind[1] + 24, eind[2] - 24, 0]);
        pen.animate(pt.map(function (q) {
          return { offset: q[0] / T[2], opacity: q[3], transform: 'translate(' + q[1] + 'px,' + (q[2] - 30) + 'px)' };
        }), { duration: T[2], fill: 'forwards', easing: 'linear' });
      };
      var begin = function () {
        var hoeken = tekenKruis();
        pad.classList.add('on');
        if (!reduce && pad.querySelector('.pen').animate) schrijf(hoeken);
      };
      if (reduce || !hasIO) {
        begin();
        return;
      }
      // Start als het blok voor 85 % in beeld staat (onder de header, boven de sticky
      // balk). Op lage vensters (liggend) is het blok hoger dan 85 % van het venster en
      // haalt de ratio 0.85 nooit: dan volstaat "zichtbaar én te groot". rootBounds
      // ontbreekt soms; dan telt alleen de eerste voorwaarde.
      var pio = new IntersectionObserver(function (en) {
        var e = en[0];
        var teGroot = e.rootBounds && e.boundingClientRect.height > e.rootBounds.height * 0.85;
        if (e.intersectionRatio >= 0.85 || (e.isIntersecting && teGroot)) { begin(); pio.disconnect(); }
      }, { rootMargin: '-56px 0px -72px 0px', threshold: [0, 0.85] });
      pio.observe(pad);
    }

    function start() {
      document.querySelectorAll('[data-lpseg-tagline]').forEach(tagline);
      document.querySelectorAll('[data-lpseg-pad]').forEach(kladblok);
    }

    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-lpseg-oprichter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    function gezin(root) {
      if (root.dataset.lpsegKlaar) return;
      root.dataset.lpsegKlaar = '1';
      if (reduce || !hasIO) return;
      var honden = root.querySelectorAll('.hond');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      honden.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height && r.top < window.innerHeight) { el.classList.add('in'); return; }
        io.observe(el);
      });
      root.classList.add('is-js');
    }

    function start() {
      document.querySelectorAll('[data-lpseg-gezin]').forEach(gezin);
    }

    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-lpseg-sporters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('IntersectionObserver' in window)) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // isIntersecting is ook waar voor een smalle rand van de volgende carrouselkaart;
    // de drempel bepaalt alleen wanneer er gemeld wordt. Dus zelf op de ratio toetsen.
    const io = new IntersectionObserver((items) => {
      for (const { target: v, intersectionRatio } of items) {
        if (intersectionRatio >= 0.25) {
          if (!v.src) v.src = v.dataset.src;
          v.play().catch(() => {});
        } else if (!v.paused) {
          v.pause();
        }
      }
    }, { threshold: [0, 0.25] });
    const init = (root) => root.querySelectorAll('.lpseg-sporters .sporter-video[data-src]').forEach((v) => io.observe(v));
    init(document);
    // De theme-editor vervangt de sectie zonder dit script opnieuw te draaien.
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-opwarmen"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-opw]').forEach((blok) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (typeof IntersectionObserver === 'undefined') return;
    const stappen = [...blok.querySelectorAll('.opw-stap')];
    const stippen = [...blok.querySelectorAll('.opw-voortgang__stip')];
    if (!stappen.length) return;
    const n = stappen.length;
    let verst = -1;

    blok.classList.add('opw-wacht');
    blok.style.setProperty('--opw-p', '0');

    const io = new IntersectionObserver(
      (items) => {
        items.forEach((item) => {
          if (!item.isIntersecting) return;
          const i = stappen.indexOf(item.target);
          item.target.classList.add('is-in');
          io.unobserve(item.target);
          if (i > verst) verst = i;
        });
        stippen.forEach((s, k) => s.classList.toggle('is-bereikt', k <= verst));
        blok.style.setProperty('--opw-p', verst < 0 ? '0' : String(verst === n - 1 ? 1 : (2 * verst + 1) / (2 * n)));
      },
      { rootMargin: '0px 0px -15% 0px', threshold: 0.2 }
    );
    stappen.forEach((s) => io.observe(s));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pakket-inhoud"] && !Shopify.designMode) return;
  try {
    
  /* Openen en sluiten van de gerechtvensters. Gedelegeerd op `document` en niet
     per knop: deze sectie wordt door `sm-pakket` opnieuw gerenderd bij een wissel
     van vleessoort, doel of omvang (`hoofd.innerHTML = …`), en luisteraars die op
     een knop hangen zijn daarna weg. Dezelfde reden waarom de drawer en de sticky
     koopbalk hun handlers daar hebben staan.

     Escape en de focus-trap komen van `<dialog>` zelf; `scroll-lock` bevriest de
     pagina via critical.css. Wat hier staat is dus alleen: welke opent, en de
     twee manieren om te sluiten. */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-pi-open]');
    if (opener) {
      /* `getElementById` en niet `querySelector('#' + id)`: een producthandle mag
         cijfers en koppeltekens dragen, en een selector die met een cijfer begint
         is ongeldig — dat gooit een SyntaxError in plaats van niets te vinden. */
      document.getElementById(opener.dataset.piOpen)?.showModal();
      return;
    }

    const sluiter = e.target.closest('[data-pi-close]');
    if (sluiter) {
      sluiter.closest('dialog')?.close();
      return;
    }

    /* Klik op de backdrop. Het event landt dan op het `<dialog>` zelf: de inhoud
       vult het element niet volledig, en alles daarbuiten is achtergrond. Toetsen
       op `e.target` en niet op een rect-meting, want dat is precies wat de
       drawer en de header hier ook doen. */
    if (e.target.classList?.contains('pi-dlg')) e.target.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pakket"] && !Shopify.designMode) return;
  try {
    
  /* Stap 1-3 zonder paginaverversing.
   *
   * Elk pakket is in Shopify een eigen product, dus de keuzeknoppen zijn links naar een
   * ander product. Dat is functioneel juist en werkt zonder JS, maar het geeft bij elke
   * klik een volledige herlading. Hieronder wordt die klik onderschept en alleen de
   * inhoud van #sm-main vervangen.
   *
   * Waarom de hele pagina ophalen en niet vijf losse section-renders: het bundeltemplate
   * telt zeven secties die allemaal van het product afhangen, en een doelpakket kan een
   * ANDER template gebruiken (de try-out-pakketten doen dat). Eén fetch houdt de pagina
   * intern consistent; vijf section-ids zouden bij een templatewissel de verkeerde
   * secties verversen.
   *
   * Waarom dit veilig is met de winkelwagen: de cart-drawer staat in layout/theme.liquid
   * BUITEN #sm-main en delegeert al zijn listeners op `document`. Een swap van #sm-main
   * laat hem dus intact, en de nieuw ingeladen "Voeg toe"-formulieren uit stap 4 worden
   * vanzelf opgepikt. Van de secties op dit template heeft alleen deze een eigen
   * javascript-blok, dus er gaat geen andere sectie-init verloren.
   */
  (() => {
    const HOOFD = '#sm-main';
    /* ⚠ Alleen links MET `data-sm-swap`. Liquid zet dat stempel uitsluitend als het
     * doelpakket hetzelfde template gebruikt als de pagina waar je staat ÉN zelf geen
     * keuzepakket is. Die tweede eis is er sinds de review van 21-08: het template
     * alléén was smaller dan de bug. Een keuzepakket hoeft geen `try-out`-suffix te
     * dragen — of Simple Bundles zijn keuzeslots injecteert hangt aan de app-configuratie,
     * niet aan het template — dus een keuzepakket op het standaardtemplate droeg dezelfde
     * suffix als een gewoon pakket en glipte langs de poort. De matrix draagt daarom een
     * achtste veld `k:` met dezelfde twee signalen die `sm-keuze-instructie` gebruikt.
     * Zonder die beperking kon een klik in stap 3 op een keuzepakket landen, en dat is geen
     * cosmetisch probleem: de zeven verplichte `properties[Meal N]`-selects worden daar
     * door de Simple Bundles-app-embed bij het laden in de DOM gezet, en een innerHTML-
     * vervanging draait die embed niet opnieuw. Je hield dan een koopknop zonder
     * maaltijdkeuze over — precies de bestelling die de poort bij de koopknop moet
     * voorkomen. Hetzelfde stempel dekt het tweede geval: sectie-CSS wordt per pagina
     * gebundeld, dus markup uit een ánder template komt binnen zonder zijn stijlen.
     * Links zonder stempel blijven gewone links en navigeren normaal. */
    const KNOPPEN = 'a.pk-seg-btn[data-sm-swap], a.pk-size-btn[data-sm-swap]';

    /* Benoemd in plaats van een IIFE: na een swap moet dit opnieuw draaien, en een
     * anonieme functie die alleen bij het laden liep zou daarna stil blijven. */
    function toonVerspring(zoek) {
      const el = document.querySelector('[data-pakket-verspring]');
      if (!el) return;
      const vanaf = new URLSearchParams(zoek ?? window.location.search).get('vanaf');
      if (!vanaf || !/^\d+$/.test(vanaf)) return;
      const maat = el.dataset.maat;
      if (vanaf === maat) return;
      el.textContent = (el.dataset.tekst || '[vlees] gaat tot [max] maaltijden. Je koos er [vanaf], dus dit is [maat].')
        .replace('[vlees]', el.dataset.vlees)
        .replace('[max]', el.dataset.max)
        .replace('[vanaf]', vanaf)
        .replace('[maat]', maat);
      el.hidden = false;
    }

    toonVerspring();

    /* Zonder deze drie valt alles terug op gewone links. Dat is geen verlies: de
     * verversing verdwijnt, de werking niet. */
    if (!window.fetch || !window.DOMParser || !(window.history && history.pushState)) return;

    let eigenGeschiedenis = false;
    let getoond = location.pathname + location.search;
    /* Laatste wint. Klik je tijdens het laden opnieuw, of druk je op Terug, dan liepen er
     * twee fetches tegelijk en won de tráágste: URL /C, inhoud en koopformulier van A.
     * Elke wissel breekt de vorige af én controleert vóór elke schrijfactie of hij nog
     * de nieuwste is (abort komt soms pas ná de laatste await). */
    let volgnummer = 0;
    let lopend = null;

    async function wissel(url, knop, push) {
      const hoofd = document.querySelector(HOOFD);
      if (!hoofd) {
        location.href = url;
        return;
      }
      if (lopend) lopend.abort();
      const ctrl = (lopend = new AbortController());
      const mijn = ++volgnummer;
      const actueel = () => mijn === volgnummer;
      hoofd.setAttribute('aria-busy', 'true');
      if (knop) knop.classList.add('is-laden');
      try {
        const r = await fetch(url, { credentials: 'same-origin', signal: ctrl.signal });
        if (!r.ok) throw new Error('status ' + r.status);
        const tekst = await r.text();
        if (!actueel()) return;
        const doc = new DOMParser().parseFromString(tekst, 'text/html');
        const nieuwHoofd = doc.querySelector(HOOFD);
        if (!nieuwHoofd) throw new Error('geen ' + HOOFD + ' in de respons');

        hoofd.innerHTML = nieuwHoofd.innerHTML;
        if (doc.title) document.title = doc.title;
        getoond = url;
        if (push) {
          history.pushState({ smPakket: true }, '', url);
          eigenGeschiedenis = true;
        }
        toonVerspring(new URL(url, location.origin).search);

        /* De knop waarop geklikt werd bestaat niet meer; zonder dit springt de focus
         * naar het begin van de pagina en raakt een toetsenbordgebruiker zijn plek kwijt. */
        const actief = hoofd.querySelector('[aria-current="true"]');
        if (actief && actief.focus) actief.focus({ preventScroll: true });

        /* Alles binnen #sm-main is zojuist vervangen, dus elk stuk JS dat een
         * element in die boom vasthoudt wijst nu naar een weesknoop. Wie hier iets
         * op de PDP hangt, luistert hierop en initialiseert zichzelf opnieuw —
         * `sm-sticky-koop` doet dat, en zonder dit signaal bleef die balk na een
         * maatwissel stil weg tot de volgende volledige paginalading (Codex-review
         * 28-08). Een event en geen directe aanroep: deze sectie hoort niet te
         * weten wélke snippets er in haar boom staan. */
        document.dispatchEvent(new CustomEvent('sm:hoofd-vervangen'));
      } catch (e) {
        /* Afgebroken door een nieuwere wissel: die neemt het over, niets doen. */
        if (!actueel()) return;
        /* Nooit stil blijven staan: een mislukte swap wordt een gewone navigatie. */
        location.href = url;
      } finally {
        if (knop) knop.classList.remove('is-laden');
        if (actueel()) {
          lopend = null;
          hoofd.removeAttribute('aria-busy');
        }
      }
    }

    document.addEventListener('click', (e) => {
      /* Laat de browser zijn werk doen bij middelklik, cmd/ctrl-klik en shift-klik —
       * dat zijn "open in nieuw tabblad" en "open in nieuw venster". */
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest && e.target.closest(KNOPPEN);
      if (!a || !a.closest(HOOFD)) return;

      const doel = new URL(a.getAttribute('href'), location.href);
      if (doel.origin !== location.origin) return;

      e.preventDefault();
      wissel(doel.pathname + doel.search, a, true);
    });

    window.addEventListener('popstate', () => {
      /* Alleen ingrijpen op geschiedenis die wij zelf hebben geschreven. Anders zou de
       * terugknop op een pagina waar nooit geswapt is een overbodige fetch doen. */
      if (!eigenGeschiedenis) return;
      const doel = location.pathname + location.search;
      if (doel === getoond) {
        /* Terug naar wat er al staat terwijl er nog een wissel laadt: die laden mag niet
         * alsnog winnen, anders klopt de URL weer niet met de inhoud. */
        if (lopend) {
          lopend.abort();
          lopend = null;
          volgnummer++;
          const hoofd = document.querySelector(HOOFD);
          if (hoofd) hoofd.removeAttribute('aria-busy');
        }
        return; // anders veranderde er alleen een hash
      }
      wissel(doel, null, false);
    });
  })();

  /* Rijteller in stap 4, bijgewerkt zonder de sectie te verversen.
   *
   * De teller wordt serverzijdig gerenderd, maar `sm-pakket` wordt bij een
   * AJAX-wagenmutatie niet opnieuw opgehaald — alleen de drawer-sectie. Zonder
   * dit bleef "1x · EUR 3,95" staan nadat je een tweede ontbijtje toevoegde.
   *
   * Bewust géén eigen /cart.js-verzoek en géén tweede schrijver: de drawer heeft
   * de kaartstanden dan al bijgewerkt en meldt dat met `sm:kaarten`. Deze functie
   * leest alleen wat er in de DOM staat en telt op.
   */
  (function () {
    /* Niet Intl: die schrijft "EUR 8,40" met een spatie, terwijl Shopify's
     * money-filter er "EUR8,40" van maakt. Dat gaf twee schrijfwijzen voor
     * hetzelfde bedrag — de ene bij het laden, de andere na een klik. */
    const geld = (cent) => '\u20ac' + (cent / 100).toFixed(2).replace('.', ',');

    function tellers() {
      document.querySelectorAll('.pk-upsell-kop[data-rij]').forEach((kop) => {
        const tag = kop.dataset.rij;
        const rij = document.querySelector('.pk-upsell-rij[data-rij="' + CSS.escape(tag) + '"]');
        const stand = kop.querySelector('.pk-upsell-stand');
        if (!rij || !stand) return;

        let aantal = 0;
        let cent = 0;
        rij.querySelectorAll('[data-card-atc]').forEach((wrap) => {
          if (!wrap.hasAttribute('data-in-cart')) return;
          // `[data-step-value]` is sinds 25-08-2026 een invoerveld (zelf een aantal
          // kunnen intikken). `textContent` is daar leeg, dus dat las stil 0.
          const veldQ = wrap.querySelector('[data-step-value]');
          const q = Number(veldQ && (veldQ.tagName === 'INPUT' ? veldQ.value : veldQ.textContent)) || 0;
          aantal += q;
          cent += q * (Number(wrap.dataset.cent) || 0);
        });

        stand.textContent = aantal + '\u00d7 \u00b7 ' + geld(cent);
        stand.toggleAttribute('hidden', aantal === 0);
        const hint = document.querySelector('.pk-upsell-hint[data-rij="' + CSS.escape(tag) + '"]');
        if (hint) hint.toggleAttribute('hidden', aantal > 0);
      });
    }

    document.addEventListener('sm:kaarten', tellers);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-details"] && !Shopify.designMode) return;
  try {
    
  // De stipjes onder de ingrediëntenrail. Versiering, geen bediening: de rail
  // scrollt met muis, trackpad, sleep en toetsenbord ook zonder dit script.
  // Daarom een observer op de kaarten en geen scroll-listener met rekenwerk —
  // die moet je bij elke resize opnieuw ijken.
  //
  // Meerdere kaarten kunnen tegelijk gemarkeerd staan; er zijn er ook twee
  // tegelijk zichtbaar. Eén "actieve" stip zou moeten kiezen welke van die twee
  // de echte is, en dat is een keuze zonder antwoord.
  document.querySelectorAll('[data-ingr-rail]').forEach((rail) => {
    const dots = rail.parentElement.querySelector('[data-ingr-dots]');
    if (!dots) return;

    const kaarten = Array.from(rail.children);
    const stippen = Array.from(dots.children);

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const stip = stippen[kaarten.indexOf(entry.target)];
          if (stip) stip.toggleAttribute('data-actief', entry.isIntersecting);
        });
      },
      { root: rail, threshold: 0.6 }
    );

    kaarten.forEach((kaart) => io.observe(kaart));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-hoofd"] && !Shopify.designMode) return;
  try {
    
  /* Portiewissel zonder naar de bovenkant te springen.
   *
   * De maatknoppen zijn echte links naar een ander PRODUCT — vier doelvarianten
   * zijn in deze winkel vier aparte producten. Dat blijft zo: een doel dat
   * alleen via JavaScript bereikbaar is bestaat niet voor een crawler, en die
   * vier vindbare pagina's zijn de reden dat het zo gebouwd is.
   *
   * Wat er wél weg kan is de sprong. Een gewone navigatie zet de nieuwe pagina
   * bovenaan, dus wie halverwege het koopblok van portie wisselt moet
   * terugscrollen naar precies de plek waar hij stond.
   *
   * ⚠ Bewaar de positie van het ELEMENT, niet `scrollY`. Een ruw pixelgetal
   * overzetten gaat mis omdat het een ándere pagina is: een gemeten wissel van
   * 570g naar 350g op Kip Koreaans zette 760 terug en landde op 1153, want het
   * andere product heeft een andere hoeveelheid inhoud erboven. Wat de bezoeker
   * wil is dat de maatrij blijft staan waar hij stond, en dat is een positie ten
   * opzichte van het scherm.
   *
   * sessionStorage en geen URL-parameter: de positie is van dit tabblad en van
   * deze klik, hij hoort niet in een deelbare link en niet in de geschiedenis.
   */
  (function () {
    const SLEUTEL = 'sm-maat-anker';
    const rij = () => document.querySelector('.pdp-maat');

    document.addEventListener('click', (event) => {
      const knop = event.target.closest('.pdp-maat__knop');
      if (!knop || knop.getAttribute('aria-current') === 'page') return;
      if (event.metaKey || event.ctrlKey || event.shiftKey) return; // nieuw tabblad
      const r = rij()?.getBoundingClientRect();
      if (!r) return;
      try {
        sessionStorage.setItem(SLEUTEL, JSON.stringify({ top: r.top, op: Date.now() }));
      } catch {
        // Private mode of geblokkeerde opslag: dan springt hij zoals vroeger.
        // Een mislukte opslag mag de navigatie nooit tegenhouden.
      }
    });

    let anker = null;
    try {
      const ruw = sessionStorage.getItem(SLEUTEL);
      if (ruw) {
        sessionStorage.removeItem(SLEUTEL);
        const gelezen = JSON.parse(ruw);
        // Alleen een verse klik telt. Zonder deze grens herstelt een tab die je
        // een uur later terugpakt een positie die nergens meer op slaat.
        if (Date.now() - gelezen.op < 10000) anker = gelezen.top;
      }
    } catch {
      // Ongeldige of ontoegankelijke opslag: niets herstellen is de juiste val.
    }

    if (anker !== null) {
      const zet = () => {
        const el = rij();
        if (!el) return;
        const doel = el.getBoundingClientRect().top + window.scrollY - anker;
        // `instant`: de pagina is net geladen, een animatie vanaf de bovenkant
        // leest als een sprong met vertraging.
        window.scrollTo({ top: Math.max(0, doel), behavior: 'instant' });
      };
      zet();
      // Nog één keer ná `load`: de productfoto's erboven hebben dan hun hoogte,
      // en zonder die tweede meting schuift de rij alsnog weg. Twee keer zetten
      // is goedkoper dan wachten op elke afbeelding apart.
      window.addEventListener('load', zet, { once: true });
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-products"] && !Shopify.designMode) return;
  try {
    
  /* Eén klik-handler op document: werkt ook na een her-render in de editor,
     zonder init-vlag per sectie. */
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-prod-schuif]');
    if (!knop) return;
    const rail = knop.closest('.prod--rail')?.querySelector('.prod-grid--rail');
    if (!rail) return;
    const kaart = rail.firstElementChild;
    const stap = kaart ? kaart.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    const zacht = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    rail.scrollBy({ left: Number(knop.dataset.prodSchuif) * stap, behavior: zacht });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-tdee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-tdee-form]');
    if (!form) return;
    event.preventDefault();

    const fout = form.querySelector('[data-tdee-fout]');
    const getal = (naam) => Number(form.elements[naam].value.trim().replace(',', '.'));
    const leeftijd = getal('leeftijd');
    const gewicht = getal('gewicht');
    const lengte = getal('lengte');
    const factor = Number(form.elements.activiteit.value);
    const vrouw = form.elements.geslacht.value === 'vrouw';

    const binnen = (waarde, min, max) => Number.isFinite(waarde) && waarde >= min && waarde <= max;
    if (!binnen(leeftijd, 14, 120) || !binnen(gewicht, 30, 300) || !binnen(lengte, 120, 250)) {
      fout.textContent = fout.dataset.tdeeFoutTekst;
      fout.hidden = false;
      form.querySelector('[data-tdee-bmr]').textContent = '—';
      form.querySelector('[data-tdee-tdee]').textContent = '—';
      form.querySelector('[data-tdee-doel]').hidden = true;
      return;
    }
    fout.hidden = true;

    const bmr = vrouw
      ? 447.593 + 9.247 * gewicht + 3.098 * lengte - 4.33 * leeftijd
      : 88.362 + 13.397 * gewicht + 4.799 * lengte - 5.677 * leeftijd;

    const nl = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL');
    form.querySelector('[data-tdee-bmr]').textContent = nl.format(Math.round(bmr));
    form.querySelector('[data-tdee-tdee]').textContent = nl.format(Math.round(bmr * factor));
    form.querySelector('[data-tdee-doel]').hidden = false;
  });

  } catch(e) { console.error(e); }
})();
})();
